var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _mask, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _mask2, _path606, _mask3, _path607, _mask4, _path608, _mask5, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _rect, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3411,
    height: 2646,
    viewBox: "0 0 3411 2646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.403 1387.46L350.903 1312.96L1947.9 682.461L1976.9 753.461L379.403 1387.46Z",
    fill: "#6CDD59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.403 1202.46L309.903 1127.96L1911.4 491.961L1941.9 566.461L338.403 1202.46Z",
    fill: "#6CDD59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.403 1202.46L309.903 1127.96L752.403 957.461L781.903 1028.46L338.403 1202.46Z",
    fill: "#F73A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M409.403 1460.46L380.903 1385.96L1977.9 755.461L2006.9 826.461L409.403 1460.46Z",
    fill: "#6CDD59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M481.403 1641.96L448.903 1567.96L2047.9 936.961L2073.9 1005.46L481.403 1641.96Z",
    fill: "#6CDD59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M510.903 1720.96L480.403 1641.46L2076.4 1004.46L2107.4 1083.96L510.903 1720.96Z",
    fill: "#6CDD59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.4 1093.46L1310.9 1018.96L1740.9 847.961L1769.9 921.961L1339.4 1093.46Z",
    fill: "#F73A3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M575.403 1889.46L546.903 1814.96L2143.9 1184.46L2172.9 1255.46L575.403 1889.46Z",
    fill: "#6CDD59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M608.403 1962.46L579.903 1887.96L2176.9 1257.46L2205.9 1328.46L608.403 1962.46Z",
    fill: "#6CDD59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2476.9 401.461L2309.9 466.461L2693.9 1433.96L2858.9 1367.96L2476.9 401.461Z",
    fill: "#6CDD59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2918.9 806.961L2752.9 873.961L2939.9 1340.96L3104.9 1274.96L2918.9 806.961Z",
    fill: "#6CDD59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M679.403 2137.46L650.903 2062.96L2247.9 1432.46L2276.9 1503.46L679.403 2137.46Z",
    fill: "#6CDD59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.9 1317.96L1049.9 1328.46L1048.9 1328.96L1079.4 1405.96L1106.4 1395.46L1075.9 1317.96Z",
    fill: "#F73A3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.9 1273.96L1148.96 1285.46L1147.9 1285.96L1177.9 1363.46L1208.9 1352.46L1177.9 1273.96Z",
    fill: "#F73A3A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.9 1199.46L1344.96 1213.96L1343.9 1214.46L1373.9 1291.96L1411.4 1277.46L1380.9 1199.46Z",
    fill: "#F73A3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2342.9 1132.46L2105.9 531.961L2030.9 561.532L2271.4 1159.96L2342.9 1132.46Z",
    fill: "#6CDD59"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M708.403 2213.46L679.903 2138.96L2276.9 1508.46L2305.9 1579.46L708.403 2213.46Z",
    fill: "#6CDD59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3249.26 1108.12C3264.84 1101.94 3272.46 1084.29 3266.28 1068.7C3260.09 1053.12 3242.44 1045.5 3226.86 1051.69C3211.27 1057.87 3203.65 1075.52 3209.84 1091.11C3216.02 1106.69 3233.67 1114.31 3249.26 1108.12Z",
    fill: "white",
    stroke: "#A1A1A1",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3265.82 1207.01C3281.4 1200.82 3289.02 1183.17 3282.84 1167.59C3276.65 1152 3259 1144.38 3243.42 1150.57C3227.83 1156.75 3220.21 1174.4 3226.4 1189.99C3232.58 1205.57 3250.23 1213.19 3265.82 1207.01Z",
    fill: "white",
    stroke: "#A1A1A1",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3169.81 1156.76L3251.11 1124.49",
    stroke: "#A1A1A1",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3201.9 1237.61L3260.49 1214.36",
    stroke: "#A1A1A1",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.003 1343.29C132.589 1337.1 140.208 1319.45 134.021 1303.87C127.835 1288.28 110.185 1280.66 94.5999 1286.85C79.0146 1293.04 71.3953 1310.69 77.5818 1326.27C83.7683 1341.86 101.418 1349.48 117.003 1343.29Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M327.202 1068.02C342.787 1061.83 350.407 1044.18 344.22 1028.6C338.034 1013.01 320.384 1005.39 304.799 1011.58C289.213 1017.77 281.594 1035.42 287.781 1051C293.967 1066.59 311.617 1074.21 327.202 1068.02Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M428.328 1027.88C443.914 1021.69 451.533 1004.04 445.347 988.457C439.16 972.872 421.51 965.253 405.925 971.439C390.34 977.626 382.721 995.275 388.907 1010.86C395.094 1026.45 412.743 1034.07 428.328 1027.88Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M751.794 1559.55C767.379 1553.37 774.998 1535.72 768.812 1520.13C762.625 1504.55 744.976 1496.93 729.39 1503.11C713.805 1509.3 706.186 1526.95 712.372 1542.54C718.559 1558.12 736.208 1565.74 751.794 1559.55Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1786.93 1319.62C1810.76 1310.16 1822.41 1283.17 1812.95 1259.35C1803.49 1235.52 1776.51 1223.87 1752.68 1233.33C1728.85 1242.79 1717.2 1269.77 1726.66 1293.6C1736.12 1317.42 1763.1 1329.07 1786.93 1319.62Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2053.09 1171.68C2059.32 1169.2 2062.37 1162.14 2059.9 1155.91C2057.42 1149.67 2050.36 1146.62 2044.12 1149.1C2037.89 1151.57 2034.84 1158.63 2037.32 1164.87C2039.79 1171.11 2046.85 1174.15 2053.09 1171.68Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.13 1438.88C1588.72 1423.56 1607.58 1379.86 1592.27 1341.27C1576.95 1302.68 1533.25 1283.81 1494.66 1299.13C1456.07 1314.45 1437.2 1358.15 1452.52 1396.74C1467.84 1435.33 1511.54 1454.2 1550.13 1438.88Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M526.559 988.886C542.145 982.7 549.764 965.05 543.578 949.465C537.391 933.88 519.741 926.26 504.156 932.447C488.571 938.633 480.951 956.283 487.138 971.868C493.324 987.454 510.974 995.073 526.559 988.886Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M627.686 948.746C643.271 942.559 650.891 924.91 644.704 909.324C638.518 893.739 620.868 886.12 605.283 892.306C589.697 898.493 582.078 916.142 588.264 931.728C594.451 947.313 612.101 954.932 627.686 948.746Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M727.921 908.957C743.507 902.77 751.126 885.121 744.939 869.535C738.753 853.95 721.103 846.331 705.518 852.517C689.933 858.704 682.313 876.353 688.5 891.939C694.686 907.524 712.336 915.143 727.921 908.957Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M829.27 868.726C844.856 862.54 852.475 844.89 846.288 829.305C840.102 813.72 822.452 806.1 806.867 812.287C791.282 818.473 783.662 836.123 789.849 851.708C796.035 867.294 813.685 874.913 829.27 868.726Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M927.278 829.824C942.864 823.637 950.483 805.988 944.296 790.403C938.11 774.817 920.46 767.198 904.875 773.384C889.289 779.571 881.67 797.221 887.857 812.806C894.043 828.391 911.693 836.01 927.278 829.824Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.63 789.594C1044.21 783.407 1051.83 765.757 1045.65 750.172C1039.46 734.587 1021.81 726.967 1006.22 733.154C990.639 739.34 983.019 756.99 989.206 772.575C995.392 788.161 1013.04 795.78 1028.63 789.594Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.64 749.097C1146.23 742.911 1153.85 725.261 1147.66 709.676C1141.48 694.091 1123.83 686.471 1108.24 692.658C1092.66 698.844 1085.04 716.494 1091.22 732.079C1097.41 747.665 1115.06 755.284 1130.64 749.097Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.77 708.957C1247.36 702.77 1254.98 685.121 1248.79 669.535C1242.6 653.95 1224.95 646.331 1209.37 652.517C1193.78 658.704 1186.16 676.353 1192.35 691.939C1198.54 707.524 1216.19 715.143 1231.77 708.957Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1330 669.965C1345.59 663.778 1353.21 646.129 1347.02 630.543C1340.83 614.958 1323.18 607.339 1307.6 613.525C1292.01 619.712 1284.39 637.361 1290.58 652.946C1296.77 668.532 1314.42 676.151 1330 669.965Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1431.35 629.734C1446.94 623.548 1454.56 605.898 1448.37 590.313C1442.18 574.727 1424.53 567.108 1408.95 573.295C1393.36 579.481 1385.74 597.131 1391.93 612.716C1398.12 628.301 1415.77 635.921 1431.35 629.734Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.57 592.336C1541.16 586.149 1548.78 568.5 1542.59 552.914C1536.4 537.329 1518.75 529.71 1503.17 535.896C1487.58 542.083 1479.96 559.732 1486.15 575.318C1492.34 590.903 1509.99 598.522 1525.57 592.336Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1626.92 552.105C1642.51 545.919 1650.13 528.269 1643.94 512.684C1637.75 497.098 1620.1 489.479 1604.52 495.666C1588.93 501.852 1581.31 519.502 1587.5 535.087C1593.69 550.672 1611.34 558.292 1626.92 552.105Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1724.93 513.199C1740.51 507.012 1748.13 489.363 1741.95 473.778C1735.76 458.192 1718.11 450.573 1702.53 456.759C1686.94 462.946 1679.32 480.596 1685.51 496.181C1691.69 511.766 1709.34 519.385 1724.93 513.199Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1826.28 472.972C1841.86 466.786 1849.48 449.136 1843.3 433.551C1837.11 417.966 1819.46 410.346 1803.87 416.533C1788.29 422.719 1780.67 440.369 1786.86 455.954C1793.04 471.54 1810.69 479.159 1826.28 472.972Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2116.52 524.07C2132.11 517.884 2139.73 500.234 2133.54 484.649C2127.35 469.063 2109.7 461.444 2094.12 467.631C2078.53 473.817 2070.91 491.467 2077.1 507.052C2083.29 522.637 2100.94 530.257 2116.52 524.07Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2154.28 619.179C2169.86 612.993 2177.48 595.343 2171.29 579.758C2165.11 564.173 2147.46 556.553 2131.87 562.74C2116.29 568.926 2108.67 586.576 2114.85 602.161C2121.04 617.747 2138.69 625.366 2154.28 619.179Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2917.82 208.836C2933.4 202.649 2941.02 185 2934.84 169.414C2928.65 153.829 2911 146.21 2895.41 152.396C2879.83 158.583 2872.21 176.232 2878.4 191.818C2884.58 207.403 2902.23 215.022 2917.82 208.836Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2954.16 300.383C2969.74 294.196 2977.36 276.546 2971.17 260.961C2964.99 245.376 2947.34 237.756 2931.75 243.943C2916.17 250.13 2908.55 267.779 2914.74 283.364C2920.92 298.95 2938.57 306.569 2954.16 300.383Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2991.56 394.605C3007.14 388.419 3014.76 370.769 3008.58 355.184C3002.39 339.598 2984.74 331.979 2969.15 338.166C2953.57 344.352 2945.95 362.002 2952.14 377.587C2958.32 393.172 2975.97 400.792 2991.56 394.605Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3025.51 480.14C3041.09 473.954 3048.71 456.304 3042.53 440.719C3036.34 425.134 3018.69 417.514 3003.11 423.701C2987.52 429.887 2979.9 447.537 2986.09 463.122C2992.27 478.708 3009.92 486.327 3025.51 480.14Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3059.11 564.781C3074.69 558.595 3082.31 540.945 3076.13 525.36C3069.94 509.774 3052.29 502.155 3036.7 508.341C3021.12 514.528 3013.5 532.178 3019.69 547.763C3025.87 563.348 3043.52 570.968 3059.11 564.781Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3168.26 837.824C3183.85 831.637 3191.47 813.988 3185.28 798.403C3179.1 782.817 3161.45 775.198 3145.86 781.384C3130.28 787.571 3122.66 805.221 3128.84 820.806C3135.03 836.391 3152.68 844.01 3168.26 837.824Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3202.31 923.582C3217.89 917.395 3225.51 899.746 3219.32 884.16C3213.14 868.575 3195.49 860.956 3179.9 867.142C3164.32 873.329 3156.7 890.978 3162.88 906.564C3169.07 922.149 3186.72 929.768 3202.31 923.582Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M3238.03 1013.57C3253.61 1007.38 3261.23 989.734 3255.04 974.149C3248.86 958.563 3231.21 950.944 3215.62 957.131C3200.04 963.317 3192.42 980.967 3198.6 996.552C3204.79 1012.14 3222.44 1019.76 3238.03 1013.57Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3277.48 1307.84C3293.06 1301.65 3300.68 1284 3294.5 1268.41C3288.31 1252.83 3270.66 1245.21 3255.08 1251.4C3239.49 1257.58 3231.87 1275.23 3238.06 1290.82C3244.24 1306.4 3261.89 1314.02 3277.48 1307.84Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2194.06 719.418C2209.65 713.231 2217.27 695.582 2211.08 679.996C2204.89 664.411 2187.25 656.792 2171.66 662.978C2156.07 669.165 2148.46 686.814 2154.64 702.4C2160.83 717.985 2178.48 725.604 2194.06 719.418Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2231.82 814.527C2247.4 808.341 2255.02 790.691 2248.84 775.106C2242.65 759.52 2225 751.901 2209.41 758.088C2193.83 764.274 2186.21 781.924 2192.4 797.509C2198.58 813.094 2216.23 820.714 2231.82 814.527Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2268.78 907.636C2284.36 901.45 2291.98 883.8 2285.79 868.215C2279.61 852.63 2261.96 845.01 2246.37 851.197C2230.79 857.383 2223.17 875.033 2229.35 890.618C2235.54 906.204 2253.19 913.823 2268.78 907.636Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2290.61 962.652C2306.2 956.466 2313.82 938.816 2307.63 923.231C2301.45 907.645 2283.8 900.026 2268.21 906.213C2252.63 912.399 2245.01 930.049 2251.19 945.634C2257.38 961.219 2275.03 968.839 2290.61 962.652Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2312.54 1017.89C2328.13 1011.71 2335.75 994.058 2329.56 978.473C2323.37 962.887 2305.72 955.268 2290.14 961.455C2274.55 967.641 2266.93 985.291 2273.12 1000.88C2279.31 1016.46 2296.96 1024.08 2312.54 1017.89Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2350.65 1113.9C2366.24 1107.71 2373.85 1090.06 2367.67 1074.48C2361.48 1058.89 2343.83 1051.27 2328.25 1057.46C2312.66 1063.65 2305.04 1081.29 2311.23 1096.88C2317.42 1112.47 2335.06 1120.08 2350.65 1113.9Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1930.3 431.679C1945.89 425.493 1953.5 407.843 1947.32 392.258C1941.13 376.673 1923.48 369.053 1907.9 375.24C1892.31 381.426 1884.69 399.076 1890.88 414.661C1897.06 430.247 1914.71 437.866 1930.3 431.679Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2031.65 391.449C2047.23 385.262 2054.85 367.613 2048.67 352.028C2042.48 336.442 2024.83 328.823 2009.25 335.009C1993.66 341.196 1986.04 358.846 1992.23 374.431C1998.41 390.016 2016.06 397.635 2031.65 391.449Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2129.66 352.547C2145.24 346.36 2152.86 328.711 2146.68 313.125C2140.49 297.54 2122.84 289.921 2107.25 296.107C2091.67 302.294 2084.05 319.943 2090.24 335.529C2096.42 351.114 2114.07 358.733 2129.66 352.547Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M2231.01 312.316C2246.59 306.13 2254.21 288.48 2248.02 272.895C2241.84 257.309 2224.19 249.69 2208.6 255.877C2193.02 262.063 2185.4 279.713 2191.58 295.298C2197.77 310.883 2215.42 318.503 2231.01 312.316Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M156.261 1442.19C171.846 1436 179.465 1418.36 173.279 1402.77C167.092 1387.18 149.443 1379.57 133.857 1385.75C118.272 1391.94 110.653 1409.59 116.839 1425.17C123.026 1440.76 140.675 1448.38 156.261 1442.19Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M197.463 1545.99C213.049 1539.8 220.668 1522.15 214.481 1506.57C208.295 1490.98 190.645 1483.36 175.06 1489.55C159.475 1495.73 151.855 1513.38 158.042 1528.97C164.228 1544.56 181.878 1552.17 197.463 1545.99Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M267.136 1721.51C282.721 1715.32 290.341 1697.68 284.154 1682.09C277.968 1666.5 260.318 1658.89 244.733 1665.07C229.147 1671.26 221.528 1688.91 227.715 1704.49C233.901 1720.08 251.551 1727.7 267.136 1721.51Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M296.358 1812.02C311.943 1805.83 319.562 1788.18 313.376 1772.6C307.189 1757.01 289.54 1749.39 273.954 1755.58C258.369 1761.77 250.75 1779.42 256.936 1795C263.123 1810.59 280.772 1818.21 296.358 1812.02Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M347.728 1941.43C363.314 1935.25 370.933 1917.6 364.746 1902.01C358.56 1886.43 340.91 1878.81 325.325 1884.99C309.74 1891.18 302.12 1908.83 308.307 1924.42C314.493 1940 332.143 1947.62 347.728 1941.43Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M388.842 2045.01C404.427 2038.82 412.047 2021.17 405.86 2005.59C399.674 1990 382.024 1982.38 366.439 1988.57C350.853 1994.75 343.234 2012.4 349.421 2027.99C355.607 2043.57 373.257 2051.19 388.842 2045.01Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M457.72 2218.53C473.305 2212.34 480.924 2194.69 474.738 2179.11C468.551 2163.52 450.902 2155.9 435.316 2162.09C419.731 2168.27 412.112 2185.92 418.298 2201.51C424.485 2217.09 442.134 2224.71 457.72 2218.53Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M498.214 2320.55C513.8 2314.36 521.419 2296.71 515.232 2281.13C509.046 2265.54 491.396 2257.92 475.811 2264.11C460.226 2270.29 452.606 2287.94 458.793 2303.53C464.979 2319.11 482.629 2326.73 498.214 2320.55Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M534.377 2411.65C549.963 2405.46 557.582 2387.81 551.395 2372.23C545.209 2356.64 527.559 2349.02 511.974 2355.21C496.389 2361.4 488.769 2379.04 494.956 2394.63C501.142 2410.22 518.792 2417.83 534.377 2411.65Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M563.732 2485.6C579.317 2479.41 586.936 2461.76 580.75 2446.18C574.563 2430.59 556.914 2422.97 541.328 2429.16C525.743 2435.34 518.124 2452.99 524.31 2468.58C530.497 2484.16 548.146 2491.78 563.732 2485.6Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M179.123 1524.47C175.394 1525.92 175.394 1525.92 175.393 1525.91L175.39 1525.91L175.378 1525.88L175.33 1525.75L175.139 1525.26L174.395 1523.34L171.555 1516.02C169.101 1509.7 165.576 1500.61 161.294 1489.58C152.73 1467.52 141.138 1437.67 129.027 1406.51C104.801 1344.18 78.507 1276.64 70.2025 1255.72C61.7273 1234.37 54.3586 1214.74 56.2038 1197.17C56.2495 1196.67 56.3347 1196.27 56.3802 1196.06C56.3823 1196.05 56.3842 1196.04 56.3861 1196.03C56.4105 1195.92 56.4179 1195.88 56.4232 1195.85C56.4251 1195.84 56.4258 1195.83 56.4259 1195.83C56.4259 1195.83 56.4259 1195.83 56.4259 1195.83C56.426 1195.83 56.426 1195.83 56.426 1195.83L56.4358 1195.72L56.4522 1195.6C58.8322 1179.11 69.6378 1165.34 92.8453 1154L92.8533 1154L92.8614 1153.99C105.498 1147.88 116.84 1146.6 126.759 1148.32C136.63 1150.04 144.798 1154.68 151.237 1159.98C157.669 1165.26 162.472 1171.28 165.657 1175.94C167.255 1178.28 168.461 1180.3 169.273 1181.74C169.68 1182.47 169.989 1183.05 170.2 1183.46C170.306 1183.66 170.387 1183.83 170.444 1183.94C170.473 1184 170.495 1184.04 170.512 1184.08L170.532 1184.12L170.538 1184.13L170.541 1184.14C170.542 1184.14 170.543 1184.14 166.933 1185.86L170.543 1184.14L170.601 1184.26L170.65 1184.39C176.073 1198.05 181.24 1212.37 185.048 1223.27C186.953 1228.72 188.52 1233.32 189.611 1236.55C190.157 1238.17 190.583 1239.45 190.874 1240.33C190.942 1240.53 191.002 1240.71 191.054 1240.87C191.115 1241.06 191.166 1241.21 191.206 1241.33L191.292 1241.59L191.313 1241.66L191.319 1241.67L191.321 1241.68L191.321 1241.68C191.321 1241.68 191.321 1241.68 187.52 1242.93L191.321 1241.68L192.522 1245.34L188.907 1246.68L117.448 1273.09L210.701 1503.61L280.608 1477.82L281.309 1479.72C282.373 1479.37 284.177 1479.53 285.971 1481.16L285.971 1481.16L285.971 1481.16L285.971 1481.16L285.974 1481.19L285.994 1481.38L286.155 1482.92L287.447 1495.27C288.362 1504.02 283.335 1512.04 278.918 1517.35C276.626 1520.11 274.3 1522.38 272.552 1523.96C271.674 1524.75 270.935 1525.38 270.407 1525.81C270.143 1526.02 269.931 1526.19 269.781 1526.31C269.706 1526.37 269.646 1526.42 269.603 1526.45L269.551 1526.49L269.535 1526.5L269.529 1526.51L269.526 1526.51C269.525 1526.51 269.524 1526.51 267.108 1523.32L268.583 1527.04L268.583 1527.04L268.583 1527.04L268.582 1527.04L268.582 1527.04L268.582 1527.04L268.582 1527.04L268.581 1527.04L268.581 1527.04L268.581 1527.04L268.58 1527.04L268.58 1527.04L268.579 1527.04L268.579 1527.04L268.578 1527.04L268.578 1527.04L268.577 1527.04L268.576 1527.04L268.575 1527.04L268.575 1527.04L268.574 1527.05L268.573 1527.05L268.572 1527.05L268.571 1527.05L268.57 1527.05L268.569 1527.05L268.567 1527.05L268.566 1527.05L268.565 1527.05L268.563 1527.05L268.562 1527.05L268.56 1527.05L268.559 1527.05L268.557 1527.05L268.555 1527.05L268.553 1527.05L268.551 1527.05L268.549 1527.05L268.547 1527.06L268.545 1527.06L268.543 1527.06L268.541 1527.06L268.538 1527.06L268.536 1527.06L268.533 1527.06L268.53 1527.06L268.527 1527.06L268.524 1527.06L268.521 1527.07L268.518 1527.07L268.515 1527.07L268.512 1527.07L268.508 1527.07L268.505 1527.07L268.501 1527.07L268.498 1527.08L268.494 1527.08L268.49 1527.08L268.486 1527.08L268.481 1527.08L268.477 1527.08L268.473 1527.09L268.468 1527.09L268.463 1527.09L268.459 1527.09L268.454 1527.09L268.449 1527.09L268.443 1527.1L268.438 1527.1L268.432 1527.1L268.427 1527.1L268.421 1527.11L268.415 1527.11L268.409 1527.11L268.403 1527.11L268.397 1527.12L268.39 1527.12L268.384 1527.12L268.377 1527.12L268.37 1527.13L268.363 1527.13L268.356 1527.13L268.348 1527.13L268.341 1527.14L268.333 1527.14L268.325 1527.14L268.317 1527.15L268.309 1527.15L268.301 1527.15L268.292 1527.16L268.284 1527.16L268.275 1527.16L268.266 1527.17L268.257 1527.17L268.247 1527.17L268.238 1527.18L268.228 1527.18L268.218 1527.19L268.208 1527.19L268.198 1527.19L268.188 1527.2L268.177 1527.2L268.166 1527.21L268.155 1527.21L268.144 1527.22L268.133 1527.22L268.121 1527.22L268.109 1527.23L268.097 1527.23L268.085 1527.24L268.073 1527.24L268.06 1527.25L268.047 1527.25L268.034 1527.26L268.021 1527.26L268.008 1527.27L267.994 1527.28L267.98 1527.28L267.966 1527.29L267.952 1527.29L267.937 1527.3L267.923 1527.3L267.908 1527.31L267.893 1527.32L267.877 1527.32L267.862 1527.33L267.846 1527.33L267.83 1527.34L267.814 1527.35L267.797 1527.35L267.78 1527.36L267.763 1527.37L267.746 1527.37L267.729 1527.38L267.711 1527.39L267.693 1527.39L267.675 1527.4L267.656 1527.41L267.638 1527.42L267.619 1527.42L267.599 1527.43L267.58 1527.44L267.56 1527.45L267.54 1527.46L267.52 1527.46L267.5 1527.47L267.479 1527.48L267.458 1527.49L267.437 1527.5L267.415 1527.5L267.393 1527.51L267.371 1527.52L267.349 1527.53L267.326 1527.54L267.303 1527.55L267.28 1527.56L267.257 1527.57L267.233 1527.58L267.209 1527.59L267.185 1527.6L267.16 1527.61L267.135 1527.62L267.11 1527.63L267.085 1527.64L267.059 1527.65L267.033 1527.66L267.007 1527.67L266.98 1527.68L266.953 1527.69L266.926 1527.7L266.899 1527.71L266.871 1527.72L266.843 1527.73L266.814 1527.74L266.786 1527.75L266.757 1527.77L266.727 1527.78L266.698 1527.79L266.668 1527.8L266.637 1527.81L266.607 1527.83L266.576 1527.84L266.545 1527.85L266.513 1527.86L266.481 1527.88L266.449 1527.89L266.417 1527.9L266.384 1527.91L266.351 1527.93L266.317 1527.94L266.283 1527.95L266.249 1527.97L266.214 1527.98L266.18 1528L266.144 1528.01L266.109 1528.02L266.073 1528.04L266.037 1528.05L266 1528.07L265.963 1528.08L265.926 1528.1L265.888 1528.11L265.85 1528.13L265.812 1528.14L265.773 1528.16L265.734 1528.17L265.695 1528.19L265.655 1528.2L265.615 1528.22L265.574 1528.24L265.533 1528.25L265.492 1528.27L265.451 1528.28L265.409 1528.3L265.366 1528.32L265.323 1528.34L265.28 1528.35L265.237 1528.37L265.193 1528.39L265.149 1528.4L265.104 1528.42L265.059 1528.44L265.014 1528.46L264.968 1528.48L264.922 1528.49L264.875 1528.51L264.828 1528.53L264.781 1528.55L264.733 1528.57L264.685 1528.59L264.636 1528.61L264.587 1528.63L264.538 1528.65L264.488 1528.67L264.438 1528.69L264.387 1528.71L264.336 1528.73L264.285 1528.75L264.233 1528.77L264.181 1528.79L264.128 1528.81L264.075 1528.83L264.022 1528.85L263.968 1528.87L263.914 1528.89L263.859 1528.92L263.804 1528.94L263.748 1528.96L263.692 1528.98L263.635 1529.01L263.579 1529.03L263.521 1529.05L263.463 1529.07L263.405 1529.1L263.347 1529.12L263.288 1529.14L263.228 1529.17L263.168 1529.19L263.108 1529.21L263.047 1529.24L262.985 1529.26L262.924 1529.29L262.861 1529.31L262.799 1529.34L262.736 1529.36L262.672 1529.39L262.608 1529.41L262.543 1529.44L262.478 1529.46L262.413 1529.49L262.347 1529.52L262.281 1529.54L262.214 1529.57L262.146 1529.6L262.079 1529.62L262.01 1529.65L261.942 1529.68L261.872 1529.71L261.803 1529.73L261.733 1529.76L261.662 1529.79L261.591 1529.82L261.519 1529.85L261.447 1529.87L261.374 1529.9L261.301 1529.93L261.228 1529.96L261.154 1529.99L261.079 1530.02L261.004 1530.05L260.928 1530.08L260.852 1530.11L260.776 1530.14L260.699 1530.17L260.621 1530.2L260.543 1530.23L260.464 1530.26L260.385 1530.3L260.306 1530.33L260.225 1530.36L260.145 1530.39L260.064 1530.42L259.982 1530.46L259.9 1530.49L259.817 1530.52L259.734 1530.55L259.65 1530.59L259.566 1530.62L259.481 1530.65L259.395 1530.69L259.31 1530.72L259.223 1530.76L259.136 1530.79L259.049 1530.83L258.961 1530.86L258.872 1530.9L258.783 1530.93L258.693 1530.97L258.603 1531L258.512 1531.04L258.421 1531.08L258.329 1531.11L258.237 1531.15L258.144 1531.19L258.05 1531.22L257.956 1531.26L257.861 1531.3L257.766 1531.34L257.67 1531.37L257.574 1531.41L257.477 1531.45L257.38 1531.49L257.282 1531.53L257.183 1531.57L257.084 1531.61L256.984 1531.65L256.884 1531.69L256.783 1531.73L256.681 1531.77L256.579 1531.81L256.477 1531.85L256.374 1531.89L256.27 1531.93L256.165 1531.97L256.06 1532.01L255.955 1532.05L255.849 1532.1L255.742 1532.14L255.634 1532.18L255.527 1532.22L255.418 1532.27L255.309 1532.31L255.199 1532.35L255.089 1532.4L254.978 1532.44L254.866 1532.49L254.754 1532.53L254.641 1532.58L254.528 1532.62L254.414 1532.67L254.299 1532.71L254.184 1532.76L254.068 1532.8L253.952 1532.85L253.835 1532.9L253.717 1532.94L253.599 1532.99L253.48 1533.04L253.36 1533.08L253.24 1533.13L253.119 1533.18L252.997 1533.23L252.875 1533.28L252.753 1533.33L252.629 1533.37L252.505 1533.42L252.38 1533.47L252.255 1533.52L252.129 1533.57L252.003 1533.62L251.875 1533.67L251.747 1533.72L251.619 1533.78L251.49 1533.83L251.36 1533.88L251.229 1533.93L251.098 1533.98L250.966 1534.03L250.834 1534.09L250.701 1534.14L250.567 1534.19L250.432 1534.25L250.297 1534.3L250.161 1534.35L250.025 1534.41L249.888 1534.46L249.75 1534.52L249.611 1534.57L249.472 1534.63L249.332 1534.68L249.191 1534.74L249.05 1534.79L248.908 1534.85L248.766 1534.91L248.622 1534.96L248.478 1535.02L248.334 1535.08L248.188 1535.14L248.042 1535.19L247.895 1535.25L247.748 1535.31L247.6 1535.37L247.451 1535.43L247.301 1535.49L247.151 1535.55L247 1535.61L246.849 1535.67L246.696 1535.73L246.543 1535.79L246.389 1535.85L246.235 1535.91L246.079 1535.97L245.923 1536.04L245.767 1536.1L245.609 1536.16L245.451 1536.22L245.292 1536.29L245.133 1536.35L244.973 1536.41L244.812 1536.48L244.65 1536.54L244.487 1536.61L244.324 1536.67L244.16 1536.74L243.995 1536.8L243.83 1536.87L243.664 1536.93L243.497 1537L243.329 1537.07L243.161 1537.13L242.992 1537.2L242.822 1537.27L242.651 1537.33L242.48 1537.4L242.308 1537.47L242.135 1537.54L241.961 1537.61L241.786 1537.68L241.611 1537.75L241.435 1537.82L241.308 1537.87L241.259 1537.89L241.081 1537.96L240.903 1538.03L240.724 1538.1L240.544 1538.17L240.364 1538.24L240.182 1538.31L240 1538.39L239.817 1538.46L239.634 1538.53L239.449 1538.61L239.264 1538.68L239.078 1538.75L238.891 1538.83L238.704 1538.9L238.515 1538.98L238.326 1539.05L238.136 1539.13L237.945 1539.2L237.754 1539.28L237.561 1539.36L237.368 1539.43L237.174 1539.51L236.98 1539.59L236.784 1539.66L236.588 1539.74L236.391 1539.82L236.193 1539.9L235.994 1539.98L235.794 1540.06L235.594 1540.14L235.393 1540.22L235.191 1540.3L234.988 1540.38L234.784 1540.46L234.58 1540.54L234.374 1540.62L234.168 1540.7L233.961 1540.78L233.754 1540.87L233.545 1540.95L233.336 1541.03L233.125 1541.12L232.914 1541.2L232.702 1541.28L232.489 1541.37L232.276 1541.45C212.842 1549.17 198.6 1545.74 189.17 1539.95C184.543 1537.11 181.192 1533.77 178.994 1531.15C177.893 1529.84 177.07 1528.69 176.514 1527.85C176.235 1527.43 176.022 1527.09 175.872 1526.84C175.797 1526.71 175.738 1526.61 175.695 1526.54C175.673 1526.5 175.656 1526.47 175.642 1526.44L175.624 1526.41L175.617 1526.4L175.614 1526.39C175.613 1526.39 175.612 1526.39 179.123 1524.47ZM179.123 1524.47L175.394 1525.92L175.488 1526.16L175.612 1526.39L179.123 1524.47Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M151.507 1162.59L60.4995 1196.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M161.145 1186.87L70.1372 1220.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M169.456 1207.81L78.4482 1241.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M178.121 1229.64L87.1133 1263.44",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M285.371 1499.83L194.363 1533.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M68.146 1182.53L210.459 1539.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6016 1157.59L136.695 1261.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M122.697 1152.37L164.712 1251.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M229.375 1504.27L241.311 1534.34",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M254.899 1495.16L266.747 1525.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7275 1294.48L117.898 1284.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M102.719 1319.65L127.889 1309.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M113.594 1347.04L138.764 1337.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M123.585 1372.21L148.756 1362.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M133.842 1398.05L159.012 1388.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M143.833 1423.22L169.003 1413.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M155.681 1453.07L180.851 1443.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M165.672 1478.24L190.842 1468.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M175.575 1503.19L200.745 1493.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M185.566 1528.36L210.736 1518.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M130.303 1305.34L204.919 1277.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M143.832 1339.43L218.448 1311.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M157.271 1373.28L231.887 1344.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M170.798 1407.36L245.415 1379.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M182.027 1435.65L256.644 1407.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M195.555 1469.73L270.171 1441.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M287.758 1708.51L362.374 1680.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M301.197 1742.36L375.813 1714.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M312.426 1770.65L387.042 1742.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M325.954 1804.73L400.57 1776.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M340.101 1840.37L414.717 1812.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M353.54 1874.23L428.156 1845.9",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M364.769 1902.52L439.385 1874.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M378.297 1936.6L452.913 1908.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M485.812 2207.46L560.429 2179.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M497.042 2235.75L571.658 2207.42",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M510.569 2269.82L585.186 2241.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M526.308 2309.47L600.924 2281.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M537.537 2337.76L612.153 2309.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M550.976 2371.62L625.592 2343.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M392.709 1972.91L467.414 1944.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M468.153 2018.76L470.466 2022.03L470.884 2021.73L471.214 2021.34L468.153 2018.76ZM468.153 2018.76C471.214 2021.34 471.214 2021.34 471.215 2021.34L471.217 2021.33L471.222 2021.33L471.237 2021.31L471.286 2021.25C471.328 2021.2 471.387 2021.13 471.462 2021.04C471.611 2020.85 471.825 2020.59 472.093 2020.25C472.63 2019.57 473.388 2018.58 474.293 2017.33C476.101 2014.84 478.51 2011.3 480.926 2007.06C485.695 1998.7 490.77 1987.16 490.825 1975.53L490.853 1969.61L485.349 1971.79L407.077 2002.86L275.272 1675.9L347.349 1645.32L350.436 1644.01L349.686 1640.74L345.787 1641.64C349.686 1640.74 349.685 1640.74 349.685 1640.74L349.684 1640.74L349.682 1640.73L349.674 1640.69C349.668 1640.67 349.659 1640.63 349.649 1640.59C349.627 1640.5 349.597 1640.37 349.557 1640.22C349.476 1639.9 349.358 1639.46 349.199 1638.9C348.882 1637.8 348.401 1636.24 347.735 1634.42C346.411 1630.8 344.315 1625.99 341.246 1621.49C338.193 1617.01 334 1612.57 328.392 1610.07C322.645 1607.52 315.833 1607.2 308.07 1610.28L308.013 1610.3L307.956 1610.32L307.898 1610.35L307.841 1610.37L307.783 1610.39L307.725 1610.42L307.668 1610.44L307.61 1610.46L307.552 1610.48L307.495 1610.51L307.437 1610.53L307.379 1610.55L307.321 1610.58L307.264 1610.6L307.206 1610.62L307.148 1610.64L307.09 1610.67L307.032 1610.69L306.974 1610.71L306.916 1610.74L306.858 1610.76L306.8 1610.78L306.742 1610.81L306.684 1610.83L306.626 1610.85L306.567 1610.87L306.509 1610.9L306.451 1610.92L306.393 1610.94L306.334 1610.97L306.276 1610.99L306.218 1611.01L306.159 1611.04L306.101 1611.06L306.043 1611.08L305.984 1611.11L305.926 1611.13L305.867 1611.15L305.809 1611.18L305.75 1611.2L305.692 1611.22L305.633 1611.25L305.574 1611.27L305.516 1611.29L305.457 1611.32L305.398 1611.34L305.34 1611.36L305.281 1611.39L305.222 1611.41L305.163 1611.43L305.104 1611.46L305.046 1611.48L304.987 1611.5L304.928 1611.53L304.869 1611.55L304.81 1611.57L304.751 1611.6L304.692 1611.62L304.633 1611.64L304.574 1611.67L304.515 1611.69L304.456 1611.71L304.396 1611.74L304.337 1611.76L304.278 1611.78L304.219 1611.81L304.16 1611.83L304.1 1611.85L304.041 1611.88L303.982 1611.9L303.923 1611.92L303.863 1611.95L303.804 1611.97L303.745 1612L303.685 1612.02L303.626 1612.04L303.566 1612.07L303.507 1612.09L303.447 1612.11L303.388 1612.14L303.328 1612.16L303.269 1612.18L303.209 1612.21L303.15 1612.23L303.09 1612.26L303.03 1612.28L302.971 1612.3L302.911 1612.33L302.851 1612.35L302.792 1612.37L302.732 1612.4L302.672 1612.42L302.612 1612.44L302.552 1612.47L302.493 1612.49L302.433 1612.52L302.373 1612.54L302.313 1612.56L302.253 1612.59L302.193 1612.61L302.133 1612.64L302.073 1612.66L302.013 1612.68L301.953 1612.71L301.893 1612.73L301.833 1612.75L301.773 1612.78L301.713 1612.8L301.653 1612.83L301.593 1612.85L301.533 1612.87L301.473 1612.9L301.412 1612.92L301.352 1612.95L301.292 1612.97L301.232 1612.99L301.171 1613.02L301.111 1613.04L301.051 1613.06L300.991 1613.09L300.93 1613.11L300.87 1613.14L300.81 1613.16L300.749 1613.18L300.689 1613.21L300.628 1613.23L300.568 1613.26L300.508 1613.28L300.447 1613.3L300.387 1613.33L300.326 1613.35L300.266 1613.38L300.205 1613.4L300.145 1613.42L300.084 1613.45L300.024 1613.47L299.963 1613.5L299.902 1613.52L299.842 1613.54L299.781 1613.57L299.72 1613.59L299.66 1613.62L299.599 1613.64L299.538 1613.66L299.478 1613.69L299.417 1613.71L299.356 1613.74L299.296 1613.76L299.235 1613.79L299.174 1613.81L299.113 1613.83L299.052 1613.86L298.992 1613.88L298.931 1613.91L298.87 1613.93L298.809 1613.95L298.748 1613.98L298.687 1614L298.626 1614.03L298.565 1614.05L298.505 1614.08L298.444 1614.1L298.383 1614.12L298.322 1614.15L298.261 1614.17L298.2 1614.2L298.139 1614.22L298.078 1614.24L298.017 1614.27L297.956 1614.29L297.895 1614.32L297.834 1614.34L297.772 1614.37L297.711 1614.39L297.65 1614.41L297.589 1614.44L297.528 1614.46L297.467 1614.49L297.406 1614.51L297.345 1614.54L297.283 1614.56L297.222 1614.58L297.161 1614.61L297.1 1614.63L297.039 1614.66L296.977 1614.68L296.916 1614.71L296.855 1614.73L296.794 1614.75L296.733 1614.78L296.671 1614.8L296.61 1614.83L296.549 1614.85L296.487 1614.88L296.426 1614.9L296.365 1614.92L296.303 1614.95L296.242 1614.97L296.181 1615L296.119 1615.02L296.058 1615.05L295.997 1615.07L295.935 1615.1L295.874 1615.12L295.813 1615.14L295.751 1615.17L295.69 1615.19L295.628 1615.22L295.567 1615.24L295.505 1615.27L295.444 1615.29L295.383 1615.31L295.321 1615.34L295.26 1615.36L295.198 1615.39L295.137 1615.41L295.075 1615.44L295.014 1615.46L294.952 1615.49L294.891 1615.51L294.829 1615.53L294.768 1615.56L294.706 1615.58L294.645 1615.61L294.583 1615.63L294.522 1615.66L294.46 1615.68L294.399 1615.71L294.337 1615.73L294.275 1615.75L294.214 1615.78L294.152 1615.8L294.091 1615.83L294.029 1615.85L293.968 1615.88L293.906 1615.9L293.844 1615.93L293.783 1615.95L293.721 1615.97L293.66 1616L293.598 1616.02L293.536 1616.05L293.475 1616.07L293.413 1616.1L293.351 1616.12L293.29 1616.15L293.228 1616.17L293.166 1616.19L293.105 1616.22L293.043 1616.24L292.982 1616.27L292.92 1616.29L292.858 1616.32L292.797 1616.34L292.735 1616.37L292.673 1616.39L292.612 1616.41L292.55 1616.44L292.488 1616.46L292.427 1616.49L292.365 1616.51L292.303 1616.54L292.241 1616.56L292.18 1616.59L292.118 1616.61L292.056 1616.63L291.995 1616.66L291.933 1616.68L291.871 1616.71L291.81 1616.73L291.748 1616.76L291.686 1616.78L291.625 1616.81L291.563 1616.83L291.501 1616.86L291.439 1616.88L291.378 1616.9L291.316 1616.93L291.254 1616.95L291.193 1616.98L291.131 1617L291.069 1617.03L291.008 1617.05L290.946 1617.08L290.884 1617.1L290.823 1617.12L290.761 1617.15L290.699 1617.17L290.637 1617.2L290.576 1617.22L290.514 1617.25L290.452 1617.27L290.391 1617.3L290.329 1617.32L290.267 1617.35L290.206 1617.37L290.144 1617.39L290.082 1617.42L290.021 1617.44L289.959 1617.47L289.897 1617.49L289.836 1617.52L289.774 1617.54L289.712 1617.57L289.651 1617.59L289.589 1617.61L289.527 1617.64L289.466 1617.66L289.404 1617.69L289.342 1617.71L289.281 1617.74L289.219 1617.76L289.157 1617.79L289.096 1617.81L289.034 1617.83L288.972 1617.86L288.911 1617.88L288.849 1617.91L288.788 1617.93L288.726 1617.96L288.664 1617.98L288.603 1618.01L288.541 1618.03L288.48 1618.05L288.418 1618.08L288.356 1618.1L288.295 1618.13L288.233 1618.15L288.172 1618.18L288.11 1618.2L288.049 1618.23L287.987 1618.25L287.926 1618.27L287.864 1618.3L287.802 1618.32L287.741 1618.35L287.679 1618.37L287.618 1618.4L287.556 1618.42L287.495 1618.45L287.433 1618.47L287.372 1618.49L287.31 1618.52L287.249 1618.54L287.188 1618.57L287.126 1618.59L287.065 1618.62L287.003 1618.64L286.942 1618.67L286.88 1618.69L286.819 1618.71L286.757 1618.74L286.696 1618.76L286.635 1618.79L286.573 1618.81L286.512 1618.84L286.451 1618.86L286.389 1618.88L286.328 1618.91L286.266 1618.93L286.205 1618.96L286.144 1618.98L286.082 1619.01L286.021 1619.03L285.96 1619.05L285.899 1619.08L285.837 1619.1L285.776 1619.13L285.715 1619.15L285.654 1619.18L285.592 1619.2L285.531 1619.23L285.47 1619.25L285.409 1619.27L285.347 1619.3L285.286 1619.32L285.225 1619.35L285.164 1619.37L285.103 1619.4L285.042 1619.42L284.98 1619.44L284.919 1619.47L284.858 1619.49L284.797 1619.52L284.736 1619.54L284.675 1619.56L284.614 1619.59L284.553 1619.61L284.492 1619.64L284.431 1619.66L284.37 1619.69L284.309 1619.71L284.248 1619.73L284.187 1619.76L284.126 1619.78L284.065 1619.81L284.004 1619.83L283.943 1619.86L283.882 1619.88L283.821 1619.9L283.76 1619.93L283.699 1619.95L283.638 1619.98L283.578 1620L283.517 1620.02L283.456 1620.05L283.395 1620.07L283.334 1620.1L283.274 1620.12L283.213 1620.15L283.152 1620.17L283.091 1620.19L283.031 1620.22L282.97 1620.24L282.909 1620.27L282.848 1620.29L282.788 1620.31L282.727 1620.34L282.666 1620.36L282.606 1620.39L282.545 1620.41L282.485 1620.43L282.424 1620.46L282.364 1620.48L282.303 1620.51L282.242 1620.53L282.182 1620.55L282.121 1620.58L282.061 1620.6L282.001 1620.63L281.94 1620.65L281.88 1620.67L281.819 1620.7L281.759 1620.72L281.698 1620.75L281.638 1620.77L281.578 1620.79L281.517 1620.82L281.457 1620.84L281.397 1620.87L281.337 1620.89L281.276 1620.91L281.216 1620.94L281.156 1620.96L281.096 1620.99L281.035 1621.01L280.975 1621.03L280.915 1621.06L280.855 1621.08L280.795 1621.11L280.735 1621.13L280.675 1621.15L280.615 1621.18L280.555 1621.2L280.495 1621.22L280.435 1621.25L280.375 1621.27L280.315 1621.3L280.255 1621.32L280.195 1621.34L280.135 1621.37L280.075 1621.39L280.015 1621.41L279.955 1621.44L279.896 1621.46L279.836 1621.49L279.776 1621.51L279.716 1621.53L279.656 1621.56L279.597 1621.58L279.537 1621.6L279.477 1621.63L279.418 1621.65L279.358 1621.68L279.298 1621.7L279.239 1621.72L279.179 1621.75L279.12 1621.77L279.06 1621.79L279.001 1621.82L278.941 1621.84L278.882 1621.86L278.822 1621.89L278.763 1621.91L278.704 1621.94L278.644 1621.96L278.585 1621.98L278.526 1622.01L278.466 1622.03L278.407 1622.05L278.348 1622.08L278.288 1622.1L278.229 1622.12L278.17 1622.15L278.111 1622.17L278.052 1622.19L277.993 1622.22L277.934 1622.24L277.875 1622.26L277.815 1622.29L277.756 1622.31L277.697 1622.33L277.638 1622.36L277.58 1622.38L277.521 1622.4L277.462 1622.43L277.403 1622.45L277.344 1622.47L277.285 1622.5L277.226 1622.52L277.168 1622.54L277.109 1622.57L277.005 1622.61L276.9 1622.65L276.796 1622.69L276.692 1622.73L276.588 1622.78L276.484 1622.82L276.38 1622.86L276.276 1622.9L276.172 1622.94L276.068 1622.98L275.964 1623.02L275.861 1623.06L275.757 1623.1L275.654 1623.15L275.55 1623.19L275.447 1623.23L275.344 1623.27L275.241 1623.31L275.138 1623.35L275.035 1623.39L274.932 1623.43L274.829 1623.47L274.726 1623.51L274.623 1623.55L274.521 1623.6L274.418 1623.64L274.316 1623.68L274.213 1623.72L274.111 1623.76L274.009 1623.8L273.907 1623.84L273.805 1623.88L273.703 1623.92L273.601 1623.96L273.499 1624L273.397 1624.04L273.296 1624.08L273.194 1624.12L273.093 1624.16L272.991 1624.2L272.89 1624.24L272.789 1624.28L272.688 1624.32L272.587 1624.36L272.486 1624.4L272.385 1624.44L272.284 1624.48L272.183 1624.52L272.083 1624.56L271.982 1624.6L271.882 1624.64L271.782 1624.68L271.681 1624.72L271.581 1624.76L271.481 1624.8L271.381 1624.84L271.282 1624.88L271.182 1624.92L271.082 1624.96L270.983 1625L270.883 1625.04L270.784 1625.08L270.685 1625.12L270.586 1625.16L270.487 1625.2L270.388 1625.24L270.289 1625.28L270.19 1625.31L270.092 1625.35L269.993 1625.39L269.895 1625.43L269.796 1625.47L269.698 1625.51L269.6 1625.55L269.502 1625.59L269.404 1625.63L269.307 1625.67L269.209 1625.7L269.111 1625.74L269.014 1625.78L268.917 1625.82L268.819 1625.86L268.722 1625.9L268.625 1625.94L268.528 1625.97L268.432 1626.01L268.335 1626.05L268.238 1626.09L268.142 1626.13L268.046 1626.17L267.949 1626.2L267.853 1626.24L267.757 1626.28L267.661 1626.32L267.566 1626.36L267.47 1626.39L267.375 1626.43L267.279 1626.47L267.184 1626.51L267.089 1626.55L266.994 1626.58L266.899 1626.62L266.804 1626.66L266.709 1626.7L266.615 1626.73L266.52 1626.77L266.426 1626.81L266.332 1626.85L266.238 1626.88L266.144 1626.92L266.05 1626.96L265.956 1627L265.863 1627.03L265.769 1627.07L265.676 1627.11L265.583 1627.14L265.49 1627.18L265.397 1627.22L265.304 1627.25L265.212 1627.29L265.119 1627.33L265.027 1627.36L264.934 1627.4L264.842 1627.44L264.75 1627.47L264.658 1627.51L264.567 1627.55L264.475 1627.58L264.384 1627.62L264.292 1627.66L264.201 1627.69L264.11 1627.73L264.019 1627.76L263.928 1627.8L263.838 1627.84L263.747 1627.87L263.657 1627.91L263.567 1627.94L263.477 1627.98L263.387 1628.02L263.297 1628.05L263.207 1628.09L263.118 1628.12L263.028 1628.16L262.939 1628.19L262.85 1628.23L262.761 1628.26L262.672 1628.3L262.584 1628.33L262.495 1628.37L262.407 1628.4L262.319 1628.44L262.231 1628.47L262.143 1628.51L262.055 1628.54L261.967 1628.58L261.88 1628.61L261.793 1628.65L261.705 1628.68L261.618 1628.72L261.532 1628.75L261.445 1628.79L261.358 1628.82L261.272 1628.85L261.186 1628.89L261.1 1628.92L261.014 1628.96L260.928 1628.99L260.842 1629.03L260.757 1629.06L260.672 1629.09L260.586 1629.13L260.501 1629.16L260.417 1629.19L260.332 1629.23L260.247 1629.26L260.163 1629.29L260.079 1629.33L259.995 1629.36L259.911 1629.39L259.827 1629.43L259.744 1629.46L259.661 1629.49L259.577 1629.53L259.494 1629.56L259.411 1629.59L259.329 1629.63L259.246 1629.66L259.164 1629.69L259.082 1629.72L259 1629.76L258.918 1629.79L258.836 1629.82L258.755 1629.85L258.673 1629.89L258.592 1629.92L258.511 1629.95L258.43 1629.98L258.349 1630.01L258.269 1630.05L258.189 1630.08L258.109 1630.11L258.029 1630.14L257.949 1630.17L257.869 1630.21L257.79 1630.24L257.71 1630.27L257.631 1630.3L257.552 1630.33L257.474 1630.36L257.395 1630.39L257.317 1630.42L257.239 1630.46L257.161 1630.49L257.083 1630.52L257.005 1630.55L256.928 1630.58L256.85 1630.61L256.773 1630.64L256.696 1630.67L256.62 1630.7L256.543 1630.73L256.467 1630.76L256.391 1630.79L256.315 1630.82L256.239 1630.85L256.163 1630.88L256.088 1630.91L256.013 1630.94L255.938 1630.97L255.863 1631L255.788 1631.03L255.714 1631.06L255.639 1631.09L255.565 1631.12L255.491 1631.15L255.418 1631.18L255.344 1631.21L255.271 1631.24L255.198 1631.27L255.125 1631.29L255.052 1631.32L254.98 1631.35L254.907 1631.38L254.835 1631.41L254.763 1631.44L254.691 1631.47L254.62 1631.5L254.549 1631.52L254.477 1631.55L254.406 1631.58L254.336 1631.61L254.265 1631.64L254.195 1631.66L254.125 1631.69L254.055 1631.72L253.985 1631.75L253.916 1631.77L253.846 1631.8L253.777 1631.83L253.708 1631.86L253.639 1631.88L253.571 1631.91L253.503 1631.94L253.435 1631.97L253.367 1631.99L253.299 1632.02L253.232 1632.05L253.164 1632.07L253.097 1632.1L253.031 1632.13L252.964 1632.15L252.898 1632.18L252.831 1632.21L252.765 1632.23L252.7 1632.26L252.634 1632.28L252.569 1632.31L252.504 1632.34L252.439 1632.36L252.374 1632.39L252.31 1632.41L252.246 1632.44L252.182 1632.46L252.118 1632.49L252.054 1632.51L251.991 1632.54L251.928 1632.56L251.865 1632.59L251.802 1632.61L251.74 1632.64L251.677 1632.66L251.615 1632.69L251.554 1632.71L251.492 1632.74L251.431 1632.76L251.369 1632.79L251.309 1632.81L251.248 1632.83L251.187 1632.86L251.127 1632.88L251.067 1632.91L251.008 1632.93L250.948 1632.95L250.889 1632.98L250.83 1633L250.771 1633.02L250.712 1633.05L250.654 1633.07L250.596 1633.09L250.538 1633.12L250.48 1633.14L250.423 1633.16L250.365 1633.18L250.308 1633.21L250.252 1633.23L250.195 1633.25L250.139 1633.27L250.083 1633.3L250.027 1633.32L249.972 1633.34L249.916 1633.36L249.861 1633.38L249.806 1633.41L249.752 1633.43L249.697 1633.45L249.643 1633.47L249.589 1633.49L249.536 1633.51L249.482 1633.53L249.429 1633.56L249.376 1633.58L249.324 1633.6L249.271 1633.62L249.219 1633.64L249.167 1633.66L249.116 1633.68L249.064 1633.7L249.013 1633.72L248.962 1633.74L248.911 1633.76L248.861 1633.78L248.811 1633.8L248.761 1633.82L248.711 1633.84L248.662 1633.86L248.613 1633.88L248.564 1633.9L248.515 1633.92L248.467 1633.94L248.418 1633.96L248.371 1633.98L248.323 1633.99L248.275 1634.01L248.228 1634.03L248.181 1634.05L248.135 1634.07L248.089 1634.09L248.042 1634.11L247.997 1634.12L247.951 1634.14L247.906 1634.16L247.861 1634.18L247.816 1634.2L247.771 1634.21L247.727 1634.23L247.683 1634.25L247.639 1634.27L247.596 1634.28L247.553 1634.3L247.51 1634.32L247.467 1634.33L247.425 1634.35L247.382 1634.37L247.34 1634.38L247.299 1634.4L247.258 1634.42L247.216 1634.43L247.176 1634.45L247.135 1634.47L247.095 1634.48L247.055 1634.5L247.015 1634.51L246.976 1634.53L246.936 1634.55L246.898 1634.56L246.859 1634.58L246.821 1634.59L246.782 1634.61L246.745 1634.62L246.707 1634.64L246.67 1634.65L246.633 1634.67L246.596 1634.68L246.56 1634.69L246.524 1634.71L246.488 1634.72L246.452 1634.74L246.417 1634.75L246.382 1634.77L246.347 1634.78L246.313 1634.79L246.278 1634.81L246.245 1634.82L246.211 1634.83L246.178 1634.85L246.145 1634.86L246.112 1634.87L246.079 1634.89L246.047 1634.9L246.015 1634.91L245.984 1634.92L245.952 1634.94L245.921 1634.95L245.891 1634.96L245.86 1634.97L245.83 1634.98L245.8 1635L245.77 1635.01L245.741 1635.02L245.712 1635.03L245.683 1635.04L245.655 1635.05L245.627 1635.06L245.599 1635.08L245.572 1635.09L245.544 1635.1L245.517 1635.11L245.491 1635.12L245.464 1635.13L245.438 1635.14L245.413 1635.15L245.387 1635.16L245.362 1635.17L245.337 1635.18L245.312 1635.19L245.288 1635.2L245.264 1635.21L245.241 1635.22L245.217 1635.23L245.194 1635.24L245.171 1635.25L245.149 1635.25L245.127 1635.26L245.105 1635.27L245.084 1635.28L245.062 1635.29L245.041 1635.3L245.021 1635.31L245 1635.31L244.981 1635.32L244.961 1635.33L244.941 1635.34L244.922 1635.34L244.904 1635.35L244.885 1635.36L244.867 1635.37L244.849 1635.37L244.832 1635.38L244.815 1635.39L244.798 1635.39L244.781 1635.4L244.765 1635.41L244.749 1635.41L244.733 1635.42L244.718 1635.43L244.703 1635.43L244.688 1635.44L244.674 1635.44L244.66 1635.45L244.646 1635.45L244.633 1635.46L244.62 1635.46L244.607 1635.47L244.595 1635.47L244.583 1635.48L244.571 1635.48L244.559 1635.49L244.548 1635.49L244.537 1635.5L244.527 1635.5L244.517 1635.51L244.507 1635.51L244.497 1635.51L244.488 1635.52L244.479 1635.52L244.471 1635.52L244.462 1635.53L244.455 1635.53L244.447 1635.53L244.44 1635.54L244.433 1635.54L244.426 1635.54L244.42 1635.54L244.414 1635.55L244.409 1635.55L244.403 1635.55L244.399 1635.55L244.394 1635.55L244.39 1635.56L244.386 1635.56L244.382 1635.56L244.379 1635.56L244.376 1635.56L244.374 1635.56L244.371 1635.56L244.37 1635.56L244.368 1635.56L244.367 1635.56L244.366 1635.57L244.366 1635.57C244.365 1635.57 244.365 1635.57 245.841 1639.28M468.153 2018.76C470.466 2022.03 470.465 2022.03 470.463 2022.03L470.46 2022.03L470.453 2022.04L470.435 2022.05L470.382 2022.09C470.34 2022.11 470.282 2022.15 470.21 2022.2C470.065 2022.3 469.861 2022.43 469.595 2022.6C469.064 2022.94 468.288 2023.42 467.259 2024C465.199 2025.18 462.124 2026.79 457.951 2028.63C449.605 2032.31 436.882 2036.89 419.139 2040.66C400.708 2044.57 389.339 2040.52 382.556 2034.65C379.25 2031.79 377.22 2028.65 376.013 2026.22C375.409 2025.01 375.005 2023.95 374.747 2023.18C374.617 2022.8 374.524 2022.48 374.459 2022.24C374.453 2022.22 374.447 2022.19 374.441 2022.17L244.146 1699.12C235.706 1680.51 235.122 1665.18 236.772 1654.38C237.595 1648.98 238.967 1644.76 240.157 1641.84C240.753 1640.38 241.303 1639.25 241.718 1638.46C241.925 1638.06 242.099 1637.75 242.228 1637.53C242.292 1637.42 242.345 1637.33 242.386 1637.27C242.406 1637.23 242.423 1637.21 242.437 1637.18L242.455 1637.15L242.462 1637.14L242.465 1637.14C242.467 1637.14 242.468 1637.13 245.841 1639.28M245.841 1639.28L242.468 1637.13L243.163 1636.04L244.365 1635.57L245.841 1639.28Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M292.859 1664.19L278.585 1626.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M317.138 1654.56L302.864 1616.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M271.698 1672.6L257.424 1634.69",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M242.251 1667.27L341.15 1628.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M252.219 1701.47L273.603 1692.98",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M264.244 1731.77L285.628 1723.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M274.854 1758.5L296.238 1750.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M286.879 1788.79L308.262 1780.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M298.55 1818.19L319.933 1809.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M310.575 1848.48L331.958 1839.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M321.185 1875.21L342.568 1866.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M333.209 1905.5L354.593 1897.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M346.03 1937.8L367.413 1929.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M358.055 1968.1L379.438 1959.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M368.665 1994.83L390.048 1986.34",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M380.689 2025.12L485.455 1988.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M426.372 2033.03L414.79 2003.85",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M453.77 2022.15L442.188 1992.97",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M243.901 1649.34L402.414 2038.93",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M641.433 2344.22L554.117 2378.88L589.484 2467.98L676.8 2433.32L641.433 2344.22Z",
    fill: "#9C9C9C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M547.707 2143.18C551.474 2141.84 551.474 2141.83 551.473 2141.83L551.472 2141.83L551.47 2141.82L551.461 2141.8L551.431 2141.72C551.419 2141.68 551.406 2141.65 551.39 2141.6C551.37 2141.55 551.347 2141.49 551.321 2141.42C551.226 2141.16 551.087 2140.8 550.906 2140.34C550.544 2139.42 550.013 2138.12 549.326 2136.58C547.958 2133.5 545.945 2129.38 543.39 2125.29C540.857 2121.25 537.665 2117.03 533.877 2113.94C530.078 2110.84 525.297 2108.58 519.828 2109.33L519.347 2109.39L518.896 2109.57L442.495 2139.9L442.156 2140.03L441.847 2140.23L443.971 2143.62C441.847 2140.23 441.844 2140.23 441.842 2140.23L441.837 2140.23L441.826 2140.24L441.799 2140.26C441.779 2140.27 441.754 2140.29 441.726 2140.31C441.668 2140.34 441.594 2140.39 441.505 2140.45C441.327 2140.58 441.087 2140.75 440.799 2140.97C440.223 2141.41 439.446 2142.04 438.569 2142.89C436.819 2144.57 434.63 2147.1 432.845 2150.56C429.187 2157.63 427.515 2168.02 433.638 2181.68C439.234 2194.17 471.625 2274.96 502.684 2352.8C518.198 2391.68 533.36 2429.77 544.643 2458.15C550.285 2472.33 554.957 2484.09 558.219 2492.3C559.849 2496.41 561.127 2499.63 561.998 2501.82L562.991 2504.32L563.245 2504.96L563.31 2505.12L563.326 2505.16L563.33 2505.17C563.331 2505.17 563.331 2505.18 567.049 2503.7L563.331 2505.18L564.803 2508.88L568.516 2507.42L1564.71 2114.82L1568.79 2113.22L1566.82 2109.3L1553.49 2082.88L1551.84 2079.6L1548.44 2080.96L591.797 2463.01L476.093 2174.68L549.128 2146.92L552.791 2145.53L551.474 2141.84L547.707 2143.18Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M482.587 2131.13L493.806 2163.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M507.98 2121.05L519.421 2153.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-140-outside-1_899_4177",
    maskUnits: "userSpaceOnUse",
    x: 424.45,
    y: 2136.16,
    width: 59.3572,
    height: 58.7966,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 424.45,
    y: 2136.16,
    width: 59.3572,
    height: 58.7966
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.288 2180.05L470.863 2172.39L459.421 2140.32"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M470.863 2172.39L472.641 2180.19L481.425 2178.19L478.398 2169.71L470.863 2172.39ZM439.066 2187.85L472.641 2180.19L469.085 2164.6L435.51 2172.25L439.066 2187.85ZM478.398 2169.71L466.956 2137.63L451.886 2143.01L463.328 2175.08L478.398 2169.71Z",
    fill: "#9C9C9C",
    mask: "url(#path-140-outside-1_899_4177)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M453.142 2209.59L481.876 2198.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M463.045 2234.54L491.779 2223.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M473.832 2261.71L502.566 2250.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M483.734 2286.66L512.468 2275.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M493.372 2310.95L522.106 2299.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M503.186 2335.67L531.92 2324.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M514.061 2363.07L542.795 2351.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M523.964 2388.02L552.698 2376.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M537.227 2421.43L565.961 2410.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M547.041 2446.15L575.775 2434.75",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M557.916 2473.55L586.65 2462.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M567.819 2498.5L596.553 2487.09",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M2413.71 279.58C2417.5 278.292 2417.5 278.292 2417.5 278.29L2417.5 278.285L2417.49 278.264L2417.46 278.184L2417.36 277.874C2417.26 277.601 2417.13 277.201 2416.95 276.685C2416.59 275.654 2416.08 274.165 2415.44 272.325C2414.16 268.648 2412.37 263.571 2410.34 257.973C2406.3 246.823 2401.26 233.447 2397.37 224.992C2393.03 215.526 2386.91 211.826 2381.29 211.012C2378.63 210.626 2376.3 210.922 2374.65 211.306C2373.82 211.499 2373.14 211.719 2372.65 211.9C2372.4 211.991 2372.2 212.072 2372.05 212.137C2372 212.159 2371.95 212.179 2371.91 212.197L2371.91 212.197L2371.62 212.309L2370.5 212.755L2366.04 214.515L2348.66 221.381C2333.43 227.396 2311.09 236.219 2282.66 247.454C2225.78 269.924 2144.49 302.039 2046.86 340.622C1851.6 417.786 1590.96 520.819 1329.44 624.29C1067.92 727.761 805.514 831.671 606.727 910.591C507.333 950.05 423.841 983.264 364.315 1007.05C334.553 1018.94 310.778 1028.48 294 1035.27C277.354 1042 267.36 1046.11 265.416 1047.08C249.786 1054.86 243.974 1068.53 242.064 1079.84C241.11 1085.49 241.103 1090.64 241.33 1094.36C241.444 1096.23 241.618 1097.76 241.766 1098.84C241.84 1099.37 241.907 1099.8 241.958 1100.1C241.984 1100.25 242.005 1100.37 242.021 1100.45C242.029 1100.49 242.035 1100.53 242.04 1100.56L242.046 1100.59L242.049 1100.6L242.049 1100.6C242.05 1100.61 242.05 1100.61 245.973 1099.83L242.05 1100.61L242.102 1100.87L242.187 1101.12L259.454 1151.76L259.486 1151.86L259.522 1151.95C264.862 1165.4 270.841 1178.67 277.095 1189.44C280.223 1194.83 283.463 1199.67 286.778 1203.62C290.065 1207.53 293.587 1210.77 297.328 1212.72C301.333 1214.81 306.305 1215.28 311.04 1215.09C315.864 1214.89 320.943 1213.99 325.498 1212.91C330.071 1211.83 334.227 1210.55 337.234 1209.54C338.741 1209.03 339.967 1208.59 340.821 1208.27C341.249 1208.11 341.584 1207.99 341.815 1207.9C341.931 1207.85 342.02 1207.82 342.083 1207.79L342.156 1207.76L342.177 1207.76L342.183 1207.75L342.185 1207.75C342.186 1207.75 342.187 1207.75 340.711 1204.03L342.187 1207.75L345.96 1206.25L344.407 1202.5L314.96 1131.41L317.163 1130.53L334.57 1123.6C349.818 1117.53 372.183 1108.63 400.651 1097.29C457.588 1074.62 538.939 1042.23 636.597 1003.35C831.913 925.572 1092.45 821.805 1353.36 717.837C1614.27 613.87 1875.54 509.701 2072.31 431.123C2170.69 391.834 2252.95 358.941 2310.98 335.671C2340 324.035 2362.96 314.804 2378.85 308.381C2386.79 305.17 2392.97 302.658 2397.26 300.898C2399.41 300.019 2401.08 299.323 2402.28 298.821C2403.33 298.379 2404.28 297.971 2404.7 297.739L2404.71 297.735C2411.14 294.167 2414.48 289.871 2416.16 286.193C2416.99 284.382 2417.38 282.782 2417.56 281.584C2417.65 280.986 2417.69 280.486 2417.71 280.109C2417.71 280.034 2417.71 279.964 2417.71 279.9C2417.72 279.8 2417.72 279.711 2417.72 279.634C2417.71 279.571 2417.71 279.516 2417.71 279.47L2417.71 279.406L2417.71 279.38L2417.71 279.367L2417.71 279.362C2417.71 279.359 2417.71 279.356 2413.71 279.58ZM2413.71 279.58L2417.5 278.292L2417.68 278.81L2417.71 279.356L2413.71 279.58Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M267.197 1050.66L324.192 1207.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M294.461 1040.1L325.4 1120.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M330.1 1025.95L361.039 1106.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M365.516 1011.89L396.678 1092.35",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M401.156 997.746L432.318 1078.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M435.236 984.221L466.175 1064.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M470.875 970.072L501.815 1050.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M506.292 956.016L537.454 1036.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M541.931 941.868L573.093 1022.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M569.552 930.904L600.491 1011.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M605.191 916.756L636.13 997.298",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M640.607 902.7L671.769 983.153",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M676.246 888.551L707.408 969.005",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M710.327 875.021L741.266 955.563",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M745.966 860.873L776.905 941.415",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M781.382 846.817L812.544 927.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M817.021 832.668L848.183 913.122",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M854.22 817.907L885.382 898.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M889.859 803.758L921.021 884.212",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M925.498 789.611L956.438 870.153",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M961.138 775.467L992.077 856.009",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M994.995 762.028L1026.16 842.481",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.63 747.879L1061.8 828.333",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.27 733.732L1097.21 814.274",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.91 719.588L1132.85 800.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1138 705.263L1168.94 785.805",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.41 691.203L1204.58 771.657",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.05 677.059L1240.21 757.512",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.69 662.912L1275.63 743.454",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.31 651.947L1303.25 732.489",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.73 637.887L1338.89 718.341",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.37 623.743L1374.53 704.196",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.01 609.596L1409.95 690.137",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1413.09 596.068L1444.03 676.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1448.5 582.008L1479.67 662.462",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1484.14 567.864L1515.3 648.317",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1519.78 553.717L1550.72 634.259",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.98 538.95L1588.14 619.403",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.62 524.803L1623.56 605.345",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1628.26 510.654L1659.2 591.196",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1663.9 496.51L1694.84 577.052",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1697.76 483.071L1728.92 563.524",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1733.39 468.924L1764.33 549.466",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1769.03 454.775L1799.97 535.317",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1804.67 440.631L1835.61 521.173",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1836.97 427.81L1867.91 508.352",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.61 413.662L1903.55 494.204",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.25 399.517L1939.19 480.059",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1943.89 385.369L1974.83 465.911",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1971.29 374.494L2002.23 455.036",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M2006.93 360.346L2037.87 440.887",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M2042.57 346.201L2073.5 426.743",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M2078.2 332.053L2109.14 412.595",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M2112.06 318.615L2143 399.157",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M2147.7 304.467L2178.64 385.009",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M2183.34 290.322L2214.28 370.864",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M2218.98 276.174L2249.92 356.716",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M2256.18 261.408L2287.12 341.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M2291.82 247.26L2322.76 327.802",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M2327.23 233.203L2358.4 313.657",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M2362.87 219.055L2394.04 299.509",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M243.702 1083.71L2393.92 223.231",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M335.919 1047.1L2393.92 223.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M253.87 1109.33L2404 248.625",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M264.922 1137.17L2415.14 276.692",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M275.731 1172.84L320.096 1157.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M286.872 1200.91L331.237 1185.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M2387.92 206.793L2809.12 43.4676",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M2419.66 286.762L2840.86 123.436",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M2399.53 205.536L2429.19 282.202",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M2409.11 201.733L2438.99 278.312",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M2421.36 196.871L2451.02 273.538",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M2430.94 193.069L2460.82 269.648",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M2444.31 187.765L2474.19 264.343",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M2454.11 183.875L2483.77 260.542",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M2466.13 179.101L2496.02 255.679",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M2475.94 175.207L2505.59 251.874",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M2486.85 170.875L2516.51 247.542",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M2496.65 166.985L2526.31 243.652",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M2508.68 162.211L2538.34 238.878",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M2518.48 158.321L2548.14 234.988",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M2531.84 153.016L2561.5 229.683",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M2541.42 149.214L2571.3 225.792",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M2553.67 144.352L2583.33 221.019",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M2563.25 140.55L2593.13 217.128",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M2574.17 136.214L2604.05 212.792",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M2583.97 132.325L2613.63 208.991",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M2596 127.55L2625.88 204.128",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M2605.8 123.657L2635.46 200.323",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M2619.16 118.352L2648.82 195.019",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M2628.96 114.461L2658.62 191.128",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M2640.99 109.688L2670.65 186.355",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M2650.79 105.797L2680.45 182.464",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M2661.71 101.469L2691.36 178.136",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M2671.28 97.667L2701.17 174.245",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M2683.53 92.8051L2713.19 169.472",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M2693.11 89.0029L2722.99 165.581",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M2706.48 83.6982L2736.36 160.277",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M2716.28 79.8089L2745.94 156.476",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M2728.31 75.034L2758.19 151.613",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M2738.11 71.1411L2767.77 147.808",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M2748.35 67.0731L2778.24 143.652",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M2758.15 63.184L2787.81 139.851",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M2770.18 58.4091L2800.06 134.988",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M2779.98 54.516L2809.64 131.183",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M2793.35 49.2113L2823.01 125.878",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M2802.93 45.409L2832.81 121.988",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M372.56 1192.68L341.788 1116.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M408.422 1178.45L377.873 1102.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M439.161 1166.25L408.611 1089.93",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M475.246 1151.92L444.473 1075.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M509.772 1138.22L478.999 1061.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M545.633 1123.98L514.861 1047.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M576.373 1111.78L545.6 1035.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M612.457 1097.46L581.685 1021.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M643.196 1085.25L612.424 1009.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M679.281 1070.93L648.509 994.703",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M710.02 1058.73L679.248 982.504",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M745.882 1044.49L715.109 968.266",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M780.407 1030.79L749.635 954.562",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M816.269 1016.55L785.497 940.328",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M847.008 1004.35L816.235 928.125",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M883.093 990.026L852.32 913.801",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M911.382 978.799L880.609 902.574",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M944.57 965.623L913.798 889.398",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M973.082 954.307L942.309 878.082",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.27 941.135L975.499 864.91",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.59 924.334L1017.82 848.109",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.89 911.514L1050.12 835.289",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.51 900.551L1077.96 824.238",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.03 887.643L1110.26 811.418",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.9 871.815L1150.13 795.59",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.43 858.111L1184.66 781.887",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.05 846.35L1214.28 770.125",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.58 832.645L1249.03 756.332",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.77 819.471L1282 743.246",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.52 805.678L1316.74 729.453",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.92 794.009L1346.37 717.695",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1411.67 780.213L1380.89 703.988",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.07 767.748L1412.3 691.523",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.6 754.045L1446.83 677.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.22 742.283L1476.45 666.059",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1541.75 728.579L1511.2 652.266",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1574.94 715.404L1544.17 639.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1609.46 701.7L1578.92 625.387",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1639.09 689.94L1608.32 613.715",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1673.84 676.147L1643.07 599.922",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1712.37 660.85L1681.6 584.625",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1747.12 647.057L1716.35 570.832",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.52 635.387L1745.97 559.074",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1811.27 621.592L1780.5 545.367",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1844.46 608.42L1813.69 532.195",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1878.99 594.717L1848.21 518.492",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.61 582.955L1877.84 506.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1943.14 569.251L1912.59 492.938",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M1980.78 554.309L1950.23 477.996",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M2068.6 428.687L1974.83 465.91L2014.62 566.145L2108.39 528.922L2068.6 428.687Z",
    fill: "#9C9C9C"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M2101.72 433.076C2098.17 424.117 2088.06 419.755 2079.1 423.311C2070.15 426.867 2065.78 436.972 2069.34 445.93L2340.07 1127.98C2343.63 1136.93 2353.73 1141.3 2362.69 1137.74C2371.65 1134.18 2376.01 1124.08 2372.46 1115.12L2101.72 433.076Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M2337.11 1196.71L2361.22 1134.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M2172.39 427.714L2067.03 469.535",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M2186 462.018L2080.64 503.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M2196.88 489.413L2091.52 531.234",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M2211.47 526.168L2041.96 593.453",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M2224.38 558.687L2054.87 625.973",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M2239.05 595.664L2069.54 662.949",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M2251.96 628.183L2082.45 695.469",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M2264.43 659.593L2094.92 726.879",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M2277.34 692.113L2107.83 759.398",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M2292.1 729.312L2122.59 796.598",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M2304.92 761.609L2135.41 828.895",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M2316.77 791.457L2147.26 858.742",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M2329.68 823.98L2160.17 891.266",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.45 861.175L2174.94 928.461",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M2357.36 893.699L2187.85 960.984",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M2370.44 926.664L2200.93 993.949",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M2383.35 959.183L2213.84 1026.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M2398.03 996.16L2228.52 1063.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M2410.94 1028.68L2241.43 1095.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M2422.61 1058.08L2253.1 1125.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M2435.52 1090.61L2266.01 1157.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M2477.3 399.504L2307.79 466.789",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M2490.21 432.023L2320.7 499.309",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M2504.89 469L2335.38 536.285",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M2517.8 501.519L2348.29 568.805",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M2530.26 532.929L2360.76 600.215",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M2543.17 565.449L2373.66 632.734",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M2557.94 602.648L2388.43 669.934",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M2570.85 635.168L2401.34 702.453",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M2582.7 665.015L2413.19 732.301",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M2595.52 697.312L2426.01 764.598",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M2610.28 734.511L2440.77 801.797",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M2623.19 767.031L2453.68 834.316",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M2636.28 800L2466.77 867.285",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M2649.19 832.519L2479.68 899.805",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M2663.95 869.718L2494.44 937.004",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M2676.77 902.015L2507.26 969.301",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M2688.44 931.418L2518.93 998.703",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M2701.35 963.941L2531.84 1031.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M2715.76 1000.25L2546.25 1067.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M2728.67 1032.77L2559.16 1100.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M2743.44 1069.96L2573.93 1137.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M2756.35 1102.49L2586.84 1169.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M2768.81 1133.89L2599.31 1201.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M2781.63 1166.19L2612.13 1233.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M2796.4 1203.39L2626.89 1270.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M2809.31 1235.91L2639.8 1303.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M2821.16 1265.76L2651.65 1333.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M2834.07 1298.28L2664.56 1365.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M2848.74 1335.25L2679.23 1402.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M2861.65 1367.78L2692.14 1435.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M2958.11 904.049L2788.82 971.246",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M2971.02 936.568L2801.73 1003.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M2985.79 973.768L2816.5 1040.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M2919.83 807.6L2750.54 874.797",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M2885.17 720.283L2715.88 787.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M2850.42 632.744L2681.13 699.941",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M2815.05 543.647L2645.77 610.844",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M2780.39 456.33L2611.11 523.527",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M2745.64 368.791L2576.36 435.988",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M2932.74 840.119L2763.45 907.316",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M2947.41 877.096L2778.13 944.293",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M2998.69 1006.29L2829.41 1073.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M3011.16 1037.7L2841.88 1104.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M3023.98 1069.99L2854.7 1137.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M3038.75 1107.19L2869.46 1174.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M3051.66 1139.71L2882.37 1206.91",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M3063.5 1169.56L2894.22 1236.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M3076.41 1202.08L2907.13 1269.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M3091.09 1239.06L2921.8 1306.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M3104 1271.58L2934.71 1338.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M2632.42 1551.59L2437.52 1628.96L2474.39 1721.84L2669.29 1644.48L2632.42 1551.59Z",
    fill: "#9C9C9C"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M2402.11 1231.83L2400.32 1232.54C2391.37 1236.1 2387 1246.2 2390.56 1255.16L2548.21 1652.32C2551.76 1661.27 2561.87 1665.64 2570.83 1662.08L2572.61 1661.37C2581.57 1657.82 2585.93 1647.71 2582.37 1638.75L2424.72 1241.6C2421.17 1232.64 2411.06 1228.28 2402.11 1231.83Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M2425.81 1303.23C2441.39 1297.04 2449.01 1279.39 2442.82 1263.81C2436.64 1248.22 2418.99 1240.6 2403.4 1246.79C2387.82 1252.98 2380.2 1270.63 2386.38 1286.21C2392.57 1301.8 2410.22 1309.42 2425.81 1303.23Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M2466.65 1406.14C2482.24 1399.95 2489.86 1382.3 2483.67 1366.72C2477.49 1351.13 2459.84 1343.51 2444.25 1349.7C2428.66 1355.89 2421.05 1373.54 2427.23 1389.12C2433.42 1404.71 2451.07 1412.33 2466.65 1406.14Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M2509.89 1515.06C2525.47 1508.88 2533.09 1491.23 2526.91 1475.64C2520.72 1460.06 2503.07 1452.44 2487.49 1458.62C2471.9 1464.81 2464.28 1482.46 2470.47 1498.04C2476.65 1513.63 2494.3 1521.25 2509.89 1515.06Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M2549.06 1613.74C2564.64 1607.55 2572.26 1589.9 2566.08 1574.32C2559.89 1558.73 2542.24 1551.11 2526.66 1557.3C2511.07 1563.48 2503.45 1581.13 2509.64 1596.72C2515.82 1612.31 2533.47 1619.92 2549.06 1613.74Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M2347.95 1220.77L2401.8 1236.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M2487.68 1222.02L2318.17 1289.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M2500.59 1254.55L2331.08 1321.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M2512.26 1283.95L2342.75 1351.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M2525.17 1316.47L2355.66 1383.75",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M2541.62 1357.9L2372.11 1425.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M2554.53 1390.42L2385.02 1457.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M2566.2 1419.82L2396.69 1487.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M2579.11 1452.34L2409.6 1519.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M2594.58 1491.32L2425.07 1558.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M2607.49 1523.84L2437.98 1591.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M2619.16 1553.25L2449.65 1620.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M2632.07 1585.77L2462.56 1653.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M414.593 1285.58L477.585 1446.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M445.999 1273.11L509.214 1433.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M349.105 1311.57L412.097 1472.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M380.512 1299.11L443.727 1459.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M543.117 1234.57L606.332 1395.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M574.746 1222.01L637.739 1382.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M477.63 1260.56L540.622 1421.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M509.26 1248L572.252 1408.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M677.878 1181.07L740.87 1341.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M709.508 1168.51L772.5 1329.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M612.391 1207.06L675.383 1367.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M644.021 1194.51L707.013 1355.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M812.639 1127.57L875.631 1288.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M847.164 1113.87L910.157 1274.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M741.138 1155.96L804.13 1316.6",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M775.663 1142.25L838.655 1302.9",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M944.95 1075.06L1007.94 1235.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M976.579 1062.5L1039.57 1223.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M879.462 1101.05L942.454 1261.69",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M910.869 1088.58L974.084 1249.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.71 1021.56L1142.7 1182.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.12 1009.1L1174.33 1169.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M1014 1047.65L1077.22 1208.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.63 1035.09L1108.62 1195.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.23 970.55L1271.45 1131.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.86 957.993L1302.86 1118.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.75 996.543L1205.74 1157.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.38 983.989L1237.37 1144.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.11 915.817L1409.11 1076.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.52 903.35L1440.74 1063.9",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.4 941.901L1343.62 1102.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.03 929.344L1375.03 1089.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.87 862.325L1543.87 1022.97",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M1512.28 849.86L1575.27 1010.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M1415.16 888.409L1478.38 1048.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M1446.79 875.852L1509.79 1036.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M1615.64 808.836L1678.63 969.478",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.16 795.129L1713.15 955.771",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.91 837.305L1606.9 997.947",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.44 823.602L1641.43 984.244",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M1747.72 756.401L1810.94 916.955",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.35 743.844L1842.35 904.486",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M1682.24 782.395L1745.23 943.037",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M1713.87 769.84L1776.86 930.482",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M1882.48 702.907L1945.48 863.548",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.11 690.352L1977.11 850.994",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M1817 728.903L1879.99 889.544",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M1848.4 716.436L1911.62 876.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M1945.52 677.886L2008.74 838.439",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M1981.64 750.698L375.508 1391.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M514.327 1536.84L577.231 1697.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M545.734 1524.37L608.861 1684.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M448.84 1562.83L511.744 1723.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M480.247 1550.37L543.374 1710.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M642.851 1485.82L705.978 1646.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M674.481 1473.26L737.385 1633.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M577.364 1511.81L640.268 1672.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M608.994 1499.26L671.898 1659.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M777.612 1432.32L840.516 1592.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M809.242 1419.77L872.146 1580.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M712.125 1458.32L775.029 1618.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M743.755 1445.77L806.659 1606.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M912.373 1378.83L975.277 1539.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M946.899 1365.13L1009.8 1525.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M840.872 1407.22L903.776 1567.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M875.398 1393.51L938.302 1553.93",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.68 1326.31L1107.59 1486.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.31 1313.76L1139.22 1474.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M979.197 1352.31L1042.1 1512.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.6 1339.84L1073.73 1500.17",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.44 1272.82L1242.35 1433.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.85 1260.35L1273.98 1420.69",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.74 1298.91L1176.86 1459.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.36 1286.35L1208.27 1446.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.97 1221.81L1371.1 1382.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 1209.25L1402.5 1369.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.48 1247.8L1305.39 1408.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.11 1235.25L1337.02 1395.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.85 1167.07L1508.75 1327.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.26 1154.61L1540.38 1314.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M1380.14 1193.16L1443.26 1353.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M1411.77 1180.6L1474.67 1341.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M1580.61 1113.58L1643.51 1274",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M1612.02 1101.12L1674.92 1261.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.9 1139.67L1578.03 1300",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M1546.53 1127.11L1609.43 1287.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.37 1060.09L1778.27 1220.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M1749.9 1046.38L1812.8 1206.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.65 1088.56L1706.55 1248.98",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.17 1074.86L1741.08 1235.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M1847.46 1007.66L1910.58 1167.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M1879.09 995.102L1941.99 1155.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M1781.97 1033.65L1844.87 1194.07",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M1813.6 1021.1L1876.5 1181.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M1982.22 954.164L2045.12 1114.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M2013.85 941.61L2076.75 1102.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.73 980.161L1979.64 1140.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M1948.14 967.694L2011.26 1128.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M2045.26 929.143L2108.38 1089.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M2081.38 1001.96L475.243 1642.34",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M613.62 1786.98L676.524 1947.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M645.027 1774.51L708.153 1934.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M548.133 1812.97L611.036 1973.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M579.54 1800.51L642.666 1960.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M742.144 1735.96L805.271 1896.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M773.774 1723.41L836.677 1883.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M676.657 1761.96L739.561 1922.38",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M708.287 1749.4L771.191 1909.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M876.905 1682.47L939.809 1842.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M908.535 1669.91L971.439 1830.33",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M811.418 1708.47L874.322 1868.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M843.048 1695.91L905.952 1856.33",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.67 1628.98L1074.57 1789.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.19 1615.27L1109.1 1775.69",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M940.165 1657.36L1003.07 1817.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M974.69 1643.66L1037.59 1804.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.98 1576.46L1206.88 1736.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.61 1563.9L1238.51 1724.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.49 1602.45L1141.39 1762.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.9 1589.99L1173.02 1750.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.74 1522.96L1341.64 1683.38",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.14 1510.5L1373.27 1670.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.03 1549.05L1276.15 1709.38",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.66 1536.49L1307.56 1696.91",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.26 1471.95L1470.39 1632.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.89 1459.39L1501.8 1619.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.77 1497.94L1404.68 1658.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.4 1485.39L1436.31 1645.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1545.14 1417.22L1608.05 1577.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M1576.55 1404.75L1639.68 1565.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M1479.43 1443.3L1542.56 1603.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M1511.06 1430.74L1573.97 1591.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M1679.9 1363.72L1742.81 1524.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M1711.31 1351.26L1774.21 1511.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.19 1389.81L1677.32 1550.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1645.82 1377.25L1708.73 1537.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.66 1310.23L1877.57 1470.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M1849.19 1296.53L1912.09 1456.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.94 1338.7L1805.84 1499.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M1777.46 1325L1840.37 1485.42",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M1946.75 1257.8L2009.88 1418.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M1978.38 1245.25L2041.28 1405.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.26 1283.8L1944.17 1444.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M1912.89 1271.24L1975.8 1431.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M2081.51 1204.31L2144.42 1364.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M2113.14 1191.75L2176.05 1352.17",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M2016.02 1230.31L2078.93 1390.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M2047.43 1217.84L2110.56 1378.17",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M2144.55 1179.29L2207.68 1339.62",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M2180.58 1251.88L574.447 1892.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M712.824 2036.9L775.728 2197.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M744.231 2024.43L807.357 2184.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M647.337 2062.89L710.24 2223.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M678.744 2050.43L741.87 2210.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M841.348 1985.88L904.475 2146.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M872.978 1973.32L935.882 2133.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M775.861 2011.88L838.765 2172.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M807.491 1999.32L870.395 2159.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M976.11 1932.39L1039.01 2092.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.74 1919.83L1070.64 2080.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M910.622 1958.38L973.526 2118.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M942.252 1945.83L1005.16 2106.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.87 1878.89L1173.77 2039.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.4 1865.19L1208.3 2025.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.37 1907.28L1102.27 2067.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.89 1893.57L1136.8 2053.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.18 1826.38L1306.08 1986.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.81 1813.82L1337.71 1974.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.69 1852.37L1240.6 2012.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.1 1839.91L1272.23 2000.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M1377.94 1772.88L1440.85 1933.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.35 1760.42L1472.47 1920.75",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.23 1798.97L1375.36 1959.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.86 1786.41L1406.77 1946.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M1506.47 1721.87L1569.59 1882.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M1538.09 1709.31L1601 1869.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.98 1747.86L1503.88 1908.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M1472.61 1735.31L1535.51 1895.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M1644.35 1667.14L1707.25 1827.56",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M1675.75 1654.67L1738.88 1815",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.64 1693.22L1641.76 1853.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.27 1680.67L1673.17 1841.09",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.11 1613.64L1842.01 1774.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M1810.51 1601.18L1873.42 1761.6",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M1713.4 1639.73L1776.52 1800.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M1745.03 1627.17L1807.93 1787.59",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M1913.87 1560.15L1976.77 1720.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M1948.39 1546.45L2011.3 1706.86",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.14 1588.62L1905.05 1749.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M1876.67 1574.92L1939.57 1735.34",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M2045.95 1507.72L2109.08 1668.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M2077.58 1495.16L2140.49 1655.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M1980.47 1533.72L2043.37 1694.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M2012.1 1521.16L2075 1681.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M2180.72 1454.23L2243.62 1614.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M2212.35 1441.67L2275.25 1602.09",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M2115.23 1480.22L2178.13 1640.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M2146.64 1467.76L2209.76 1628.09",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M2243.75 1429.21L2306.88 1589.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.87 1502.02L673.74 2142.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.35 1350.81L1492.63 1352.28L1494.1 1356L1499.85 1370.48L1501.33 1374.2L1505.04 1372.72L1537.79 1359.72L1541.51 1358.25L1540.03 1354.53L1534.28 1340.05L1532.81 1336.33L1529.09 1337.81L1496.35 1350.81Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M1508.64 1381.77L1504.92 1383.24L1506.39 1386.96L1512.14 1401.44L1513.62 1405.16L1517.33 1403.68L1550.08 1390.68L1553.8 1389.21L1552.32 1385.49L1546.57 1371.01L1545.1 1367.29L1541.38 1368.77L1508.64 1381.77Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M1520.8 1365L1525.4 1376.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-607-outside-2_899_4177",
    maskUnits: "userSpaceOnUse",
    x: 1369.12,
    y: 796.843,
    width: 546.787,
    height: 552.952,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1369.12,
    y: 796.843,
    width: 546.787,
    height: 552.952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522.58 1296.73L1734.25 817.956L1755.37 825.043L1530.57 1341.52"
  }))), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M1734.25 817.956L1736.8 810.372L1729.89 808.052L1726.94 814.721L1734.25 817.956ZM1755.37 825.043L1762.71 828.236L1766.19 820.235L1757.92 817.459L1755.37 825.043ZM1529.9 1299.97L1741.57 821.191L1726.94 814.721L1515.27 1293.5L1529.9 1299.97ZM1731.71 825.541L1752.83 832.628L1757.92 817.459L1736.8 810.372L1731.71 825.541ZM1748.04 821.851L1523.23 1338.33L1537.9 1344.72L1762.71 828.236L1748.04 821.851Z",
    fill: "#9C9C9C",
    mask: "url(#path-607-outside-2_899_4177)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-609-outside-3_899_4177",
    maskUnits: "userSpaceOnUse",
    x: 1536.38,
    y: 1220.64,
    width: 554.563,
    height: 564.652,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1536.38,
    y: 1220.64,
    width: 554.563,
    height: 564.652
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.73 1420.94L2058.99 1628.89L2068.75 1604.13L1544.17 1379.7"
  }))), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M2058.99 1628.89L2055.83 1636.24L2063.4 1639.49L2066.43 1631.83L2058.99 1628.89ZM2068.75 1604.13L2076.19 1607.06L2079.05 1599.83L2071.9 1596.77L2068.75 1604.13ZM1571.57 1428.3L2055.83 1636.24L2062.14 1621.54L1577.88 1413.59L1571.57 1428.3ZM2066.43 1631.83L2076.19 1607.06L2061.31 1601.19L2051.54 1625.96L2066.43 1631.83ZM2071.9 1596.77L1547.32 1372.34L1541.03 1387.05L2065.61 1611.48L2071.9 1596.77Z",
    fill: "#9C9C9C",
    mask: "url(#path-609-outside-3_899_4177)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-611-outside-4_899_4177",
    maskUnits: "userSpaceOnUse",
    x: 1649.72,
    y: 941.304,
    width: 458.85,
    height: 572.074,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1649.72,
    y: 941.304,
    width: 458.85,
    height: 572.074
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.95 1055.17C1656.95 1055.17 1682.08 1061.96 1700.34 1054.71C1718.61 1047.46 1727.72 1035.33 1727.72 1035.33L1989.31 1149.37C1989.31 1149.37 1990.16 1165.79 1995.02 1178.04C1999.89 1190.3 2018.49 1205.34 2018.49 1205.34L1897.26 1476.75C1897.26 1476.75 1873.69 1470.64 1863.31 1476.31C1852.84 1481.75 1839.44 1501.26 1839.44 1501.26"
  }))), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.72 1035.33L1730.91 1028L1725.12 1025.47L1721.32 1030.53L1727.72 1035.33ZM1989.31 1149.37L1997.3 1148.96L1997.05 1144.01L1992.51 1142.04L1989.31 1149.37ZM2018.49 1205.34L2025.8 1208.6L2028.31 1202.99L2023.52 1199.12L2018.49 1205.34ZM1897.26 1476.75L1895.26 1484.5L1901.81 1486.2L1904.57 1480.02L1897.26 1476.75ZM1863.31 1476.31L1867 1483.41L1867.07 1483.37L1867.14 1483.33L1863.31 1476.31ZM1656.95 1055.17C1654.87 1062.9 1654.87 1062.9 1654.87 1062.9C1654.87 1062.9 1654.87 1062.9 1654.87 1062.9C1654.88 1062.9 1654.88 1062.9 1654.88 1062.9C1654.89 1062.9 1654.9 1062.9 1654.91 1062.91C1654.93 1062.91 1654.96 1062.92 1654.99 1062.93C1655.06 1062.95 1655.15 1062.97 1655.27 1063C1655.49 1063.06 1655.82 1063.14 1656.22 1063.23C1657.03 1063.43 1658.18 1063.68 1659.61 1063.97C1662.46 1064.53 1666.45 1065.2 1671.06 1065.62C1680.07 1066.46 1692.42 1066.46 1703.29 1062.14L1697.39 1047.27C1690 1050.21 1680.65 1050.44 1672.53 1049.69C1668.58 1049.33 1665.15 1048.75 1662.72 1048.27C1661.5 1048.03 1660.55 1047.82 1659.91 1047.67C1659.6 1047.59 1659.36 1047.53 1659.21 1047.49C1659.14 1047.47 1659.08 1047.46 1659.05 1047.45C1659.04 1047.45 1659.03 1047.45 1659.03 1047.45C1659.03 1047.45 1659.03 1047.45 1659.03 1047.45C1659.03 1047.45 1659.03 1047.45 1659.03 1047.45C1659.03 1047.45 1659.03 1047.45 1659.03 1047.45C1659.04 1047.45 1659.04 1047.45 1656.95 1055.17ZM1703.29 1062.14C1713.42 1058.12 1721.02 1052.75 1726.11 1048.36C1728.66 1046.16 1730.59 1044.19 1731.92 1042.73C1732.59 1042 1733.1 1041.4 1733.47 1040.95C1733.65 1040.73 1733.79 1040.55 1733.9 1040.41C1733.95 1040.35 1734 1040.29 1734.04 1040.24C1734.05 1040.22 1734.07 1040.2 1734.08 1040.18C1734.09 1040.17 1734.09 1040.16 1734.1 1040.16C1734.1 1040.15 1734.1 1040.15 1734.11 1040.15C1734.11 1040.15 1734.11 1040.14 1734.11 1040.14C1734.11 1040.14 1734.11 1040.14 1727.72 1035.33C1721.32 1030.53 1721.32 1030.52 1721.33 1030.52C1721.33 1030.52 1721.33 1030.52 1721.33 1030.52C1721.33 1030.52 1721.33 1030.51 1721.33 1030.51C1721.34 1030.51 1721.34 1030.5 1721.34 1030.5C1721.35 1030.5 1721.35 1030.49 1721.35 1030.49C1721.35 1030.49 1721.34 1030.51 1721.32 1030.53C1721.29 1030.57 1721.22 1030.66 1721.12 1030.78C1720.91 1031.03 1720.57 1031.43 1720.1 1031.95C1719.15 1032.99 1717.66 1034.51 1715.65 1036.25C1711.62 1039.73 1705.53 1044.04 1697.39 1047.27L1703.29 1062.14ZM1724.52 1042.67L1986.12 1156.7L1992.51 1142.04L1730.91 1028L1724.52 1042.67ZM1989.31 1149.37C1981.32 1149.78 1981.32 1149.78 1981.32 1149.78C1981.32 1149.78 1981.32 1149.79 1981.32 1149.79C1981.32 1149.79 1981.32 1149.79 1981.32 1149.79C1981.33 1149.8 1981.33 1149.8 1981.33 1149.81C1981.33 1149.82 1981.33 1149.84 1981.33 1149.86C1981.33 1149.9 1981.33 1149.96 1981.34 1150.04C1981.35 1150.18 1981.36 1150.39 1981.38 1150.65C1981.41 1151.17 1981.47 1151.92 1981.55 1152.84C1981.72 1154.69 1981.99 1157.27 1982.43 1160.26C1983.28 1166.14 1984.82 1174.02 1987.59 1181L2002.46 1175.09C2000.36 1169.82 1999.05 1163.36 1998.26 1157.96C1997.88 1155.32 1997.63 1153.03 1997.49 1151.41C1997.42 1150.61 1997.37 1149.97 1997.34 1149.55C1997.33 1149.34 1997.32 1149.18 1997.31 1149.08C1997.31 1149.03 1997.3 1148.99 1997.3 1148.97C1997.3 1148.96 1997.3 1148.96 1997.3 1148.95C1997.3 1148.95 1997.3 1148.95 1997.3 1148.95C1997.3 1148.95 1997.3 1148.95 1997.3 1148.95C1997.3 1148.96 1997.3 1148.96 1997.3 1148.96C1997.3 1148.96 1997.3 1148.96 1989.31 1149.37ZM1987.59 1181C1990.67 1188.77 1997.61 1196.6 2002.91 1201.93C2005.69 1204.73 2008.31 1207.12 2010.22 1208.81C2011.19 1209.65 2011.98 1210.33 2012.54 1210.8C2012.82 1211.03 2013.04 1211.22 2013.2 1211.35C2013.28 1211.41 2013.34 1211.46 2013.38 1211.5C2013.4 1211.52 2013.42 1211.53 2013.44 1211.54C2013.44 1211.55 2013.45 1211.55 2013.45 1211.55C2013.46 1211.56 2013.46 1211.56 2013.46 1211.56C2013.46 1211.56 2013.46 1211.56 2013.46 1211.56C2013.46 1211.56 2013.46 1211.56 2018.49 1205.34C2023.52 1199.12 2023.52 1199.12 2023.52 1199.12C2023.52 1199.12 2023.53 1199.12 2023.53 1199.12C2023.53 1199.12 2023.53 1199.12 2023.53 1199.12C2023.53 1199.12 2023.53 1199.12 2023.52 1199.12C2023.52 1199.12 2023.51 1199.11 2023.5 1199.1C2023.47 1199.08 2023.43 1199.04 2023.37 1198.99C2023.25 1198.9 2023.07 1198.75 2022.83 1198.55C2022.35 1198.15 2021.65 1197.55 2020.79 1196.79C2019.07 1195.28 2016.73 1193.14 2014.26 1190.65C2009.03 1185.39 2004.23 1179.57 2002.46 1175.09L1987.59 1181ZM2011.19 1202.08L1889.96 1473.49L1904.57 1480.02L2025.8 1208.6L2011.19 1202.08ZM1897.26 1476.75C1899.27 1469.01 1899.27 1469.01 1899.27 1469.01C1899.27 1469.01 1899.27 1469.01 1899.27 1469.01C1899.26 1469.01 1899.26 1469.01 1899.26 1469.01C1899.25 1469 1899.25 1469 1899.24 1469C1899.22 1469 1899.19 1468.99 1899.16 1468.98C1899.11 1468.97 1899.02 1468.95 1898.92 1468.92C1898.72 1468.87 1898.43 1468.8 1898.06 1468.71C1897.33 1468.54 1896.29 1468.31 1895.02 1468.05C1892.49 1467.53 1888.98 1466.9 1885.09 1466.46C1881.23 1466.02 1876.81 1465.74 1872.51 1466C1868.34 1466.26 1863.57 1467.05 1859.48 1469.29L1867.14 1483.33C1868.25 1482.73 1870.31 1482.17 1873.48 1481.97C1876.53 1481.79 1879.95 1481.97 1883.28 1482.35C1886.57 1482.73 1889.6 1483.27 1891.82 1483.73C1892.92 1483.95 1893.8 1484.15 1894.4 1484.29C1894.7 1484.36 1894.93 1484.42 1895.07 1484.45C1895.15 1484.47 1895.2 1484.48 1895.23 1484.49C1895.24 1484.49 1895.25 1484.5 1895.26 1484.5C1895.26 1484.5 1895.26 1484.5 1895.26 1484.5C1895.26 1484.5 1895.26 1484.5 1895.26 1484.5C1895.26 1484.5 1895.26 1484.5 1895.26 1484.5C1895.26 1484.5 1895.26 1484.5 1897.26 1476.75ZM1859.62 1469.21C1852.81 1472.75 1845.94 1480.17 1841.32 1485.68C1838.86 1488.61 1836.76 1491.35 1835.27 1493.36C1834.52 1494.36 1833.93 1495.19 1833.51 1495.77C1833.31 1496.06 1833.14 1496.29 1833.03 1496.45C1832.97 1496.53 1832.93 1496.6 1832.9 1496.64C1832.88 1496.67 1832.87 1496.68 1832.86 1496.7C1832.86 1496.71 1832.85 1496.71 1832.85 1496.72C1832.85 1496.72 1832.85 1496.72 1832.85 1496.72C1832.84 1496.72 1832.84 1496.72 1832.84 1496.72C1832.84 1496.72 1832.84 1496.72 1839.44 1501.26C1846.03 1505.79 1846.03 1505.79 1846.03 1505.79C1846.03 1505.79 1846.03 1505.79 1846.03 1505.79C1846.03 1505.79 1846.03 1505.79 1846.03 1505.79C1846.03 1505.79 1846.03 1505.79 1846.03 1505.78C1846.03 1505.78 1846.04 1505.77 1846.05 1505.76C1846.07 1505.73 1846.1 1505.68 1846.15 1505.62C1846.24 1505.49 1846.37 1505.3 1846.55 1505.04C1846.91 1504.54 1847.44 1503.8 1848.12 1502.89C1849.47 1501.07 1851.37 1498.59 1853.58 1495.97C1858.27 1490.37 1863.34 1485.31 1867 1483.41L1859.62 1469.21Z",
    fill: "#9C9C9C",
    mask: "url(#path-611-outside-4_899_4177)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-613-outside-5_899_4177",
    maskUnits: "userSpaceOnUse",
    x: 1744.03,
    y: 725.731,
    width: 583.95,
    height: 879.34,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1744.03,
    y: 725.731,
    width: 583.95,
    height: 879.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.77 842.742C1749.77 842.742 2061.36 811.878 2174.01 1129.43C2268.8 1396.83 2054.98 1594.12 2054.98 1594.12"
  }))), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M2174.01 1129.43L2181.55 1126.76L2181.55 1126.76L2174.01 1129.43ZM1749.77 842.742C1750.55 850.703 1750.55 850.704 1750.55 850.704C1750.55 850.704 1750.55 850.704 1750.55 850.703C1750.56 850.703 1750.56 850.702 1750.58 850.701C1750.6 850.698 1750.65 850.694 1750.71 850.688C1750.84 850.677 1751.04 850.659 1751.32 850.636C1751.86 850.592 1752.7 850.528 1753.81 850.457C1756.02 850.314 1759.32 850.143 1763.58 850.034C1772.1 849.815 1784.47 849.848 1799.68 850.864C1830.12 852.897 1871.86 858.861 1917.02 874.561C2007.11 905.882 2111.09 975.992 2166.47 1132.11L2181.55 1126.76C2124.28 965.319 2016.14 892.084 1922.27 859.448C1875.45 843.17 1832.25 837.003 1800.75 834.899C1784.99 833.847 1772.13 833.81 1763.17 834.039C1758.69 834.153 1755.19 834.335 1752.78 834.49C1751.58 834.567 1750.65 834.638 1750.01 834.69C1749.69 834.716 1749.44 834.738 1749.27 834.754C1749.18 834.762 1749.11 834.768 1749.07 834.773C1749.04 834.775 1749.02 834.777 1749.01 834.778C1749 834.779 1748.99 834.78 1748.99 834.78C1748.98 834.781 1748.98 834.781 1749.77 842.742ZM2166.47 1132.11C2212.93 1263.17 2183.84 1377.04 2142.9 1458.46C2122.42 1499.19 2099.01 1531.72 2080.72 1554.05C2071.58 1565.21 2063.74 1573.81 2058.21 1579.59C2055.44 1582.49 2053.25 1584.67 2051.77 1586.13C2051.02 1586.85 2050.46 1587.4 2050.08 1587.75C2049.9 1587.93 2049.76 1588.06 2049.67 1588.14C2049.63 1588.18 2049.6 1588.21 2049.58 1588.23C2049.57 1588.24 2049.56 1588.24 2049.56 1588.25C2049.56 1588.25 2049.56 1588.25 2049.56 1588.25C2049.56 1588.25 2049.56 1588.25 2054.98 1594.12C2060.41 1600 2060.41 1600 2060.42 1600C2060.42 1599.99 2060.42 1599.99 2060.43 1599.99C2060.44 1599.98 2060.45 1599.96 2060.47 1599.95C2060.5 1599.92 2060.55 1599.88 2060.6 1599.82C2060.72 1599.71 2060.89 1599.56 2061.1 1599.35C2061.53 1598.94 2062.16 1598.34 2062.96 1597.56C2064.56 1595.99 2066.87 1593.68 2069.77 1590.66C2075.55 1584.61 2083.67 1575.7 2093.1 1564.19C2111.95 1541.17 2136.07 1507.66 2157.19 1465.65C2199.46 1381.57 2229.88 1263.09 2181.55 1126.76L2166.47 1132.11Z",
    fill: "#9C9C9C",
    mask: "url(#path-613-outside-5_899_4177)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M677.051 2337.82L707.015 2417.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M709.795 2324.82L739.758 2404.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M743.652 2311.38L773.838 2390.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M776.395 2298.38L806.581 2377.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M811.589 2284.41L841.775 2363.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M844.556 2271.33L874.519 2350.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M878.413 2257.89L908.599 2337.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M911.156 2244.89L941.342 2324.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M942.787 2232.34L972.973 2311.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M975.531 2219.34L1005.72 2298.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.61 2205.81L1039.57 2285.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.35 2192.81L1072.32 2272.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.55 2178.84L1107.51 2258.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.29 2165.85L1140.25 2245.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.15 2152.41L1174.33 2231.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.11 2139.32L1207.08 2218.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.31 2125.35L1242.27 2204.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.05 2112.36L1275.02 2191.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.91 2098.92L1309.1 2178.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.65 2085.92L1341.84 2165.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.85 2071.95L1377.03 2151.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.81 2058.86L1409.78 2138.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M1413.67 2045.43L1443.86 2124.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M1446.41 2032.43L1476.6 2111.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M1475.59 2020.84L1505.78 2100.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M1508.34 2007.85L1538.52 2087.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M1542.42 1994.32L1567.61 2061.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M1575.16 1981.32L1600.35 2048.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.35 1967.35L1635.54 2034.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.1 1954.35L1668.29 2021.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M1676.96 1940.91L1707.14 2020.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M1709.92 1927.82L1739.88 2007.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M1746.9 1913.15L1776.86 1992.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.64 1900.15L1809.6 1979.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M1813.5 1886.71L1843.68 1966.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.46 1873.63L1876.43 1953.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.66 1859.66L1911.62 1939.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.4 1846.66L1944.36 1926.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M1948.26 1833.22L1978.44 1912.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M1981 1820.22L2011.19 1899.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M2012.63 1807.67L2042.82 1886.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M2045.38 1794.67L2075.56 1873.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M2079.46 1781.14L2109.42 1860.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M2112.2 1768.15L2142.16 1847.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M2147.39 1754.18L2177.36 1833.56",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M2180.14 1741.18L2210.32 1820.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M2214.22 1727.65L2244.18 1807.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M2246.96 1714.65L2276.92 1794.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M2282.38 1700.59L2312.56 1779.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M2315.34 1687.51L2345.31 1766.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M2349.2 1674.07L2379.39 1753.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M2381.94 1661.07L2412.13 1740.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M2670.4 1546.57L2700.58 1625.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M2703.14 1533.58L2733.33 1612.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M2737.22 1520.05L2767.19 1599.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M2769.97 1507.05L2800.15 1586.34",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M2805.61 1492.9L2835.57 1572.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.35 1479.91L2868.31 1559.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M2872.43 1466.38L2902.39 1545.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M2905.17 1453.38L2935.14 1532.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M2417.14 1647.1L2447.32 1726.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M2449.88 1634.1L2480.07 1713.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M2483.96 1620.57L2513.92 1699.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M2516.7 1607.58L2546.89 1686.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M2388.02 437.004L2774.95 1406.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M2726.86 338.349L2650.45 368.676L2576.28 398.119L2566.64 373.84L2717.22 314.07L2726.86 338.349Z",
    fill: "#9C9C9C"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M2762.05 427.001L2685.64 457.328L2611.47 486.771L2601.83 462.492L2752.41 402.722L2762.05 427.001Z",
    fill: "#9C9C9C"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M2797.41 516.099L2721.01 546.426L2646.84 575.869L2637.2 551.59L2787.77 491.82L2797.41 516.099Z",
    fill: "#9C9C9C"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M2832.07 603.415L2755.67 633.742L2681.5 663.185L2671.86 638.906L2822.43 579.136L2832.07 603.415Z",
    fill: "#9C9C9C"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M2866.11 689.169L2789.71 719.496L2715.54 748.939L2705.9 724.66L2856.47 664.89L2866.11 689.169Z",
    fill: "#9C9C9C"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M2901.48 778.271L2825.08 808.598L2750.9 838.041L2741.27 813.762L2891.84 753.992L2901.48 778.271Z",
    fill: "#9C9C9C"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M3026.2 1306.84L2650.45 368.676",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M2639.04 377.59L2645.49 393.85",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M2630.46 385.605L2629.01 381.877L2625.28 383.326L2608.97 389.665L2605.24 391.114L2606.69 394.843L2611.12 406.235L2612.57 409.963L2616.3 408.514L2632.61 402.175L2636.33 400.726L2634.88 396.998L2630.46 385.605Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M2643.6 387.124L2631.48 391.676",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M2653.18 413.227L2659.64 429.487",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M2644.8 421.144L2643.35 417.416L2639.62 418.865L2623.31 425.204L2619.58 426.653L2621.03 430.382L2625.46 441.774L2626.91 445.502L2630.64 444.053L2646.95 437.714L2650.67 436.265L2649.23 432.537L2644.8 421.144Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M2657.74 422.765L2645.63 427.316",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M2673.61 464.684L2680.06 480.944",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M2665.05 472.711L2663.6 468.983L2659.88 470.432L2643.57 476.77L2639.84 478.22L2641.29 481.948L2645.72 493.34L2647.17 497.069L2650.9 495.619L2667.2 489.281L2670.93 487.832L2669.48 484.103L2665.05 472.711Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M2678.17 474.218L2666.05 478.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M2687.76 500.324L2694.21 516.585",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M2679.17 508.34L2677.72 504.611L2673.99 506.061L2657.69 512.399L2653.96 513.849L2655.41 517.577L2659.84 528.969L2661.29 532.698L2665.01 531.248L2681.32 524.91L2685.05 523.46L2683.6 519.732L2679.17 508.34Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M2692.31 509.858L2680.2 514.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M2710.83 558.461L2717.29 574.721",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M2702.34 566.519L2700.89 562.791L2697.16 564.24L2680.86 570.579L2677.13 572.028L2678.58 575.757L2683.01 587.149L2684.46 590.877L2688.19 589.428L2704.49 583.089L2708.22 581.64L2706.77 577.912L2702.34 566.519Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M2715.39 567.995L2703.36 572.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M2724.98 594.098L2731.43 610.358",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M2716.46 602.144L2715.01 598.416L2711.28 599.865L2694.98 606.204L2691.25 607.653L2692.7 611.382L2697.12 622.774L2698.57 626.502L2702.3 625.053L2718.61 618.714L2722.34 617.265L2720.89 613.537L2716.46 602.144Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M2729.54 603.636L2717.42 608.188",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M2745.4 645.551L2751.86 661.811",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M2736.94 653.625L2735.49 649.897L2731.76 651.346L2715.46 657.684L2711.73 659.134L2713.18 662.862L2717.6 674.254L2719.05 677.983L2722.78 676.533L2739.09 670.195L2742.82 668.746L2741.37 665.017L2736.94 653.625Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M2749.96 655.089L2737.93 659.863",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M2759.55 681.191L2766 697.452",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M2751.06 689.254L2749.61 685.526L2745.88 686.975L2729.57 693.313L2725.85 694.763L2727.29 698.491L2731.72 709.883L2733.17 713.612L2736.9 712.162L2753.21 705.824L2756.94 704.375L2755.49 700.646L2751.06 689.254Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M2764.11 690.729L2752.08 695.504",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M2779.97 732.645L2786.43 748.905",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M2771.47 740.703L2770.02 736.975L2766.29 738.424L2749.99 744.763L2746.26 746.212L2747.71 749.94L2752.14 761.333L2753.59 765.061L2757.31 763.612L2773.62 757.273L2777.35 755.824L2775.9 752.095L2771.47 740.703Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M2784.53 742.183L2772.42 746.734",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M2794.12 768.285L2800.58 784.546",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M2785.59 776.332L2784.14 772.604L2780.41 774.053L2764.11 780.392L2760.38 781.841L2761.83 785.569L2766.25 796.961L2767.7 800.69L2771.43 799.241L2787.74 792.902L2791.47 791.453L2790.02 787.724L2785.59 776.332Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M2798.68 777.823L2786.56 782.375",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M2851.94 190.973L2858.39 207.233",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M2843.58 199.141L2842.13 195.412L2838.4 196.862L2822.1 203.2L2818.37 204.649L2819.82 208.378L2824.25 219.77L2825.7 223.498L2829.42 222.049L2845.73 215.71L2849.46 214.261L2848.01 210.533L2843.58 199.141Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M2856.72 200.422L2844.38 205.062",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M2866.09 226.613L2872.54 242.874",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M2857.7 234.769L2856.25 231.041L2852.52 232.49L2836.22 238.829L2832.49 240.278L2833.94 244.007L2838.36 255.399L2839.81 259.127L2843.54 257.678L2859.85 251.339L2863.58 249.89L2862.13 246.162L2857.7 234.769Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M2870.87 236.063L2858.53 240.703",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M2987.82 539.785L2994.19 555.823",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M2979.37 547.613L2977.92 543.885L2974.2 545.334L2957.89 551.673L2954.16 553.122L2955.61 556.85L2960.04 568.242L2961.49 571.971L2965.22 570.522L2981.52 564.183L2985.25 562.734L2983.8 559.005L2979.37 547.613Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M2992.51 549.012L2980.26 553.875",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M3001.97 575.426L3008.33 591.463",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M2993.49 583.242L2992.04 579.514L2988.31 580.963L2972.01 587.302L2968.28 588.751L2969.73 592.479L2974.16 603.871L2975.61 607.6L2979.33 606.15L2995.64 599.812L2999.37 598.363L2997.92 594.634L2993.49 583.242Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M3006.66 584.653L2994.41 589.516",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M2952.36 450.469L2958.82 466.729",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M2943.86 458.453L2942.41 454.725L2938.68 456.174L2922.37 462.513L2918.65 463.962L2920.1 467.69L2924.52 479.082L2925.97 482.811L2929.7 481.361L2946.01 475.023L2949.74 473.573L2948.29 469.845L2943.86 458.453Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M2957.15 459.914L2944.81 464.555",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M2966.51 486.109L2972.97 502.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M2957.98 494.078L2956.53 490.35L2952.8 491.799L2936.49 498.138L2932.76 499.587L2934.21 503.315L2938.64 514.707L2940.09 518.436L2943.82 516.986L2960.12 510.648L2963.85 509.198L2962.4 505.47L2957.98 494.078Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M2971.29 495.555L2958.95 500.195",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M2917.71 363.148L2924.07 379.186",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M2909.33 371.004L2907.88 367.276L2904.15 368.725L2887.84 375.063L2884.12 376.513L2885.56 380.241L2889.99 391.633L2891.44 395.361L2895.17 393.912L2911.48 387.574L2915.21 386.124L2913.76 382.396L2909.33 371.004Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M2922.4 372.375L2910.15 377.238",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M2931.85 398.789L2938.22 414.827",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M2923.44 406.633L2922 402.904L2918.27 404.354L2901.96 410.692L2898.23 412.142L2899.68 415.87L2904.11 427.262L2905.56 430.99L2909.29 429.541L2925.59 423.202L2929.32 421.753L2927.87 418.025L2923.44 406.633Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M2936.54 408.016L2924.29 412.879",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M2882.25 273.828L2888.7 290.089",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M2873.81 281.836L2872.36 278.108L2868.63 279.557L2852.33 285.895L2848.6 287.345L2850.05 291.073L2854.48 302.465L2855.93 306.193L2859.65 304.744L2875.96 298.406L2879.69 296.956L2878.24 293.228L2873.81 281.836Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M2887.03 283.274L2874.78 288.137",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M2896.4 309.469L2902.85 325.729",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M2887.93 317.465L2886.48 313.736L2882.75 315.186L2866.45 321.524L2862.72 322.974L2864.17 326.702L2868.59 338.094L2870.04 341.822L2873.77 340.373L2890.08 334.034L2893.81 332.585L2892.36 328.857L2887.93 317.465Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M2901.18 318.914L2888.84 323.555",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M3130.61 899.52L3137.07 915.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M3122.12 907.519L3120.67 903.791L3116.94 905.24L3100.63 911.579L3096.91 913.028L3098.36 916.757L3102.78 928.149L3104.23 931.877L3107.96 930.428L3124.27 924.089L3128 922.64L3126.55 918.912L3122.12 907.519Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M3135.4 908.969L3123.06 913.609",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M3144.76 935.16L3151.22 951.421",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M3136.24 943.148L3134.79 939.42L3131.06 940.869L3114.75 947.208L3111.02 948.657L3112.47 952.386L3116.9 963.778L3118.35 967.506L3122.08 966.057L3138.39 959.718L3142.11 958.269L3140.66 954.54L3136.24 943.148Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M3149.54 944.606L3137.2 949.246",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M3092.59 803.738L3098.96 819.776",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M3084.17 811.586L3082.72 807.858L3079 809.307L3062.69 815.645L3058.96 817.095L3060.41 820.823L3064.84 832.215L3066.29 835.943L3070.02 834.494L3086.32 828.156L3090.05 826.706L3088.6 822.978L3084.17 811.586Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M3097.29 812.961L3085.04 817.824",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M3106.74 839.379L3113.11 855.417",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M3098.29 847.211L3096.84 843.483L3093.11 844.932L3076.81 851.27L3073.08 852.72L3074.53 856.448L3078.96 867.84L3080.41 871.568L3084.13 870.119L3100.44 863.781L3104.17 862.331L3102.72 858.603L3098.29 847.211Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M3111.43 848.602L3099.18 853.465",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M3057.85 716.199L3064.3 732.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M3049.42 724.227L3047.97 720.498L3044.24 721.947L3027.94 728.286L3024.21 729.735L3025.66 733.464L3030.09 744.856L3031.53 748.584L3035.26 747.135L3051.57 740.796L3055.3 739.347L3053.85 735.619L3049.42 724.227Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M3062.63 725.649L3050.38 730.512",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M3071.99 751.84L3078.45 768.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M3063.54 759.852L3062.09 756.123L3058.36 757.572L3042.05 763.911L3038.33 765.36L3039.77 769.089L3044.2 780.481L3045.65 784.209L3049.38 782.76L3065.69 776.421L3069.41 774.972L3067.97 771.244L3063.54 759.852Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M3076.77 761.285L3064.52 766.148",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M3022.48 627.105L3028.93 643.366",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M3013.9 635.062L3012.46 631.334L3008.73 632.783L2992.42 639.122L2988.69 640.571L2990.14 644.3L2994.57 655.692L2996.02 659.42L2999.75 657.971L3016.05 651.632L3019.78 650.183L3018.33 646.455L3013.9 635.062Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M3027.26 636.551L3014.92 641.191",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M3036.63 662.742L3042.99 678.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M3028.25 670.602L3026.8 666.873L3023.07 668.322L3006.76 674.661L3003.03 676.11L3004.48 679.839L3008.91 691.231L3010.36 694.959L3014.09 693.51L3030.4 687.171L3034.12 685.722L3032.67 681.994L3028.25 670.602Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M3041.32 671.965L3029.07 676.828",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M2814.37 819.293L2820.82 835.553",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M2805.76 827.305L2804.31 823.576L2800.59 825.026L2784.28 831.364L2780.55 832.813L2782 836.542L2786.43 847.934L2787.88 851.662L2791.61 850.213L2807.91 843.875L2811.64 842.425L2810.19 838.697L2805.76 827.305Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M2818.93 828.827L2806.81 833.379",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M2832.19 137.966L2838.42 154.315",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M2823.76 145.969L2822.31 142.24L2818.59 143.69L2802.28 150.028L2798.55 151.478L2800 155.206L2804.43 166.598L2805.88 170.326L2809.61 168.877L2825.91 162.538L2829.64 161.089L2828.19 157.361L2823.76 145.969Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M2836.66 147.28L2824.63 152.055",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M3174.72 1000.88L3180.86 1017.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M3166.19 1008.86L3164.74 1005.13L3161.01 1006.58L3144.7 1012.91L3140.97 1014.36L3142.42 1018.09L3146.85 1029.48L3148.3 1033.21L3152.03 1031.76L3168.34 1025.43L3172.06 1023.98L3170.61 1020.25L3166.19 1008.86Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M3179.19 1010.19L3167.16 1014.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M2923.06 1520.54L2906.8 1526.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M2915.11 1512.18L2918.83 1510.71L2917.36 1506.99L2910.93 1490.72L2909.47 1487L2905.75 1488.46L2894.38 1492.95L2890.66 1494.42L2892.13 1498.14L2898.55 1514.41L2900.02 1518.14L2903.74 1516.67L2915.11 1512.18Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M2913.62 1525.32L2908.84 1513.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M2978.08 1498.7L2961.82 1505.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M2970.13 1490.33L2973.85 1488.86L2972.38 1485.14L2965.96 1468.87L2964.49 1465.15L2960.77 1466.62L2949.4 1471.11L2945.68 1472.58L2947.15 1476.3L2953.57 1492.57L2955.04 1496.29L2958.76 1494.82L2970.13 1490.33Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M2968.63 1503.48L2963.86 1491.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M3009.71 1486.14L2993.45 1492.6",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M3001.61 1477.84L3005.33 1476.37L3003.86 1472.65L2997.44 1456.38L2995.97 1452.66L2992.25 1454.13L2980.88 1458.62L2977.16 1460.09L2978.63 1463.81L2985.05 1480.08L2986.52 1483.8L2990.24 1482.33L3001.61 1477.84Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M3000.26 1490.93L2995.49 1478.9",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M3063.39 1464.83L3047.35 1471.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M3055.53 1456.44L3059.26 1454.97L3057.79 1451.25L3051.36 1434.97L3049.89 1431.25L3046.17 1432.72L3034.8 1437.21L3031.08 1438.68L3032.55 1442.4L3038.98 1458.67L3040.45 1462.39L3044.17 1460.92L3055.53 1456.44Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M3054.17 1469.52L3049.39 1457.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M3095.02 1452.28L3078.76 1458.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M3087.02 1443.94L3090.74 1442.47L3089.27 1438.75L3082.84 1422.48L3081.37 1418.76L3077.65 1420.23L3066.29 1424.71L3062.57 1426.18L3064.03 1429.9L3070.46 1446.18L3071.93 1449.9L3075.65 1448.43L3087.02 1443.94Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M3085.58 1457.06L3080.8 1445.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M3152.05 1429.64L3135.79 1436.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M3144.09 1421.28L3147.81 1419.81L3146.34 1416.09L3139.92 1399.82L3138.45 1396.1L3134.73 1397.57L3123.36 1402.06L3119.64 1403.53L3121.11 1407.25L3127.53 1423.52L3129 1427.24L3132.72 1425.77L3144.09 1421.28Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M3142.6 1434.43L3137.82 1422.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M3183.68 1417.09L3167.42 1423.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M3175.57 1408.79L3179.29 1407.32L3177.82 1403.6L3171.4 1387.33L3169.93 1383.6L3166.21 1385.07L3154.84 1389.56L3151.12 1391.03L3152.59 1394.75L3159.01 1411.02L3160.48 1414.74L3164.2 1413.28L3175.57 1408.79Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M3174.23 1421.87L3169.45 1409.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M2668.44 364.625L2674.9 380.885",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M2703.5 355.279L2702 351.572L2698.29 353.074L2682.08 359.644L2678.37 361.147L2679.87 364.854L2684.46 376.182L2685.96 379.889L2689.67 378.387L2705.88 371.816L2709.59 370.314L2708.09 366.607L2703.5 355.279Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M2671.44 374.781L2683.6 369.696",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M2682.59 400.266L2688.96 416.303",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M2717.84 390.818L2716.34 387.111L2712.63 388.613L2696.41 395.183L2692.71 396.686L2694.21 400.393L2698.8 411.721L2700.3 415.428L2704.01 413.926L2720.22 407.355L2723.93 405.853L2722.43 402.146L2717.84 390.818Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M2685.5 410.199L2697.75 405.336",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M2703.01 451.719L2709.47 467.979",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M2738.1 442.384L2736.59 438.677L2732.89 440.179L2716.67 446.75L2712.97 448.252L2714.47 451.959L2719.06 463.287L2720.56 466.994L2724.27 465.492L2740.48 458.922L2744.19 457.42L2742.69 453.712L2738.1 442.384Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M2706.01 461.875L2718.18 456.789",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M2717.16 487.359L2723.62 503.62",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M2752.21 478.013L2750.71 474.306L2747.01 475.808L2730.79 482.379L2727.08 483.881L2728.59 487.588L2733.18 498.916L2734.68 502.623L2738.39 501.121L2754.6 494.551L2758.31 493.048L2756.8 489.341L2752.21 478.013Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M2720.16 497.516L2732.32 492.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M2740.24 545.496L2746.69 561.757",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M2775.38 536.193L2773.88 532.486L2770.17 533.988L2753.96 540.558L2750.25 542.061L2751.76 545.768L2756.35 557.096L2757.85 560.803L2761.56 559.301L2777.77 552.73L2781.48 551.228L2779.97 547.521L2775.38 536.193Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M2743.24 555.652L2755.4 550.567",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M2754.39 581.137L2760.84 597.397",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M2789.5 571.822L2788 568.115L2784.29 569.617L2768.08 576.187L2764.37 577.689L2765.87 581.397L2770.46 592.725L2771.97 596.432L2775.67 594.93L2791.89 588.359L2795.59 586.857L2794.09 583.15L2789.5 571.822Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M2757.38 591.293L2769.55 586.207",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M2774.81 632.59L2781.26 648.85",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M2809.98 623.299L2808.48 619.591L2804.77 621.093L2788.56 627.664L2784.85 629.166L2786.35 632.873L2790.94 644.201L2792.45 647.908L2796.15 646.406L2812.37 639.836L2816.08 638.334L2814.57 634.626L2809.98 623.299Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M2777.81 642.746L2790.06 637.883",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M2788.96 668.23L2795.41 684.491",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M2824.1 658.927L2822.6 655.22L2818.89 656.722L2802.68 663.293L2798.97 664.795L2800.47 668.502L2805.06 679.83L2806.56 683.537L2810.27 682.035L2826.49 675.465L2830.19 673.963L2828.69 670.255L2824.1 658.927Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M2791.96 678.387L2804.12 673.301",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M2809.38 719.684L2815.83 735.944",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M2844.51 710.377L2843.01 706.669L2839.31 708.172L2823.09 714.742L2819.38 716.244L2820.89 719.952L2825.48 731.279L2826.98 734.987L2830.69 733.484L2846.9 726.914L2850.61 725.412L2849.11 721.704L2844.51 710.377Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M2812.38 729.84L2824.54 724.754",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M2823.53 755.324L2829.98 771.585",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M2858.63 746.006L2857.13 742.298L2853.42 743.801L2837.21 750.371L2833.5 751.873L2835 755.58L2839.59 766.908L2841.1 770.616L2844.8 769.113L2861.02 762.543L2864.72 761.041L2863.22 757.333L2858.63 746.006Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M2826.53 765.481L2838.69 760.395",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M2843.77 806.328L2850.23 822.588",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M2879.03 796.892L2877.53 793.185L2873.82 794.687L2857.61 801.258L2853.9 802.76L2855.4 806.467L2859.99 817.795L2861.49 821.502L2865.2 820L2881.41 813.43L2885.12 811.927L2883.62 808.22L2879.03 796.892Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M2846.77 816.484L2858.94 811.399",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M2858 155.567L2779.81 186.602L2787.06 204.867L2865.25 173.832L2858 155.567Z",
    fill: "#9C9C9C"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M2892.66 242.884L2814.47 273.918L2821.72 292.183L2899.91 261.149L2892.66 242.884Z",
    fill: "#9C9C9C"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M2927.4 330.423L2849.22 361.457L2856.47 379.722L2934.65 348.688L2927.4 330.423Z",
    fill: "#9C9C9C"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M2961.36 415.954L2883.17 446.988L2890.42 465.253L2968.61 434.219L2961.36 415.954Z",
    fill: "#9C9C9C"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M2998.23 508.841L2920.04 539.875L2927.29 558.14L3005.48 527.106L2998.23 508.841Z",
    fill: "#9C9C9C"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M3032.18 594.376L2953.99 625.41L2961.24 643.675L3039.43 612.641L3032.18 594.376Z",
    fill: "#9C9C9C"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M3066.84 681.688L2988.65 712.723L2995.9 730.988L3074.09 699.953L3066.84 681.688Z",
    fill: "#9C9C9C"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M3099.99 765.219L3021.81 796.254L3029.06 814.519L3107.24 783.485L3099.99 765.219Z",
    fill: "#9C9C9C"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M3135.27 854.094L3057.09 885.129L3071.86 922.327L3150.04 891.293L3135.27 854.094Z",
    fill: "#9C9C9C"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M3172.94 948.985L3094.76 980.02L3109.52 1017.22L3187.7 986.184L3172.94 948.985Z",
    fill: "#9C9C9C"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M2803.43 240.91L2876.09 211.552",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M2836.5 324.219L2909.16 294.861",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M2872.22 414.207L2944.88 384.849",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M2906.88 501.524L2979.54 472.166",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M2942.51 591.289L3015.17 561.931",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M2977.17 678.606L3049.92 649.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M3011.39 764.809L3084.05 735.451",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M3046.14 852.348L3118.8 822.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M3085.13 950.578L3157.79 921.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M3034.41 583.098L3061.14 572.488C3068.37 569.617 3071.85 561.345 3068.93 554.003L2893.95 113.19C2891.1 106.014 2882.87 102.458 2875.69 105.306L2848.96 115.916C2841.78 118.765 2838.23 127.002 2841.08 134.179L3016.14 575.214C3018.99 582.391 3027.23 585.947 3034.41 583.098Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M2858 155.566L2899.87 138.944",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M2874.62 197.441L2916.49 180.819",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M2892.92 243.551L2934.8 226.928",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M2909.54 285.426L2951.42 268.803",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M2927.85 331.535L2969.72 314.913",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M2944.47 373.41L2986.34 356.788",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M2962.77 419.52L3004.65 402.897",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M2979.39 461.395L3021.27 444.772",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M2994.34 499.039L3036.21 482.417",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M3010.96 540.914L3052.83 524.292",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M3070.8 564.348L3024.91 582.562L3110.94 799.294L3156.83 781.079L3070.8 564.348Z",
    fill: "#9C9C9C"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M3136.39 1072.56L3239.52 1031.62",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M3151.77 1111.32L3245.1 1074.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M3184.93 1194.85L3254.87 1167.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M3218.26 1278.82L3268.83 1258.75",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M3157.17 1073.59L3261.44 1342.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeDasharray: "11 11"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M2961.11 1437.11L2990.33 1512.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M3048.43 1402.45L3077.64 1478",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M3136.63 1367.43L3165.85 1442.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M3293.22 1305.27L3167.37 1355.23L3198.05 1432.52L3323.9 1382.57L3293.22 1305.27Z",
    fill: "#9C9C9C"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M3101.06 1374.6L3077.67 1383.88L3109.15 1463.18L3132.53 1453.89L3101.06 1374.6Z",
    fill: "#9C9C9C"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M3015.38 1411.44L2991.99 1420.72L3023.47 1500.02L3046.86 1490.74L3015.38 1411.44Z",
    fill: "#9C9C9C"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M2927.4 1446.36L2904.01 1455.65L2935.49 1534.95L2958.87 1525.66L2927.4 1446.36Z",
    fill: "#9C9C9C"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M606.403 1592.96L580.403 1603.46L579.403 1603.96L609.903 1680.96L636.903 1670.46L606.403 1592.96Z",
    fill: "#F73A3A"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M837.903 1499.96L811.903 1510.46L810.903 1510.96L841.403 1587.96L868.403 1577.46L837.903 1499.96Z",
    fill: "#F73A3A"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M937.903 1749.46L910.903 1760.46L909.903 1760.96L937.903 1831.96L965.403 1820.46L937.903 1749.46Z",
    fill: "#F73A3A"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M902.903 2052.96L875.903 2063.96L874.903 2064.46L902.903 2136.46L930.403 2125.46L902.903 2052.96Z",
    fill: "#F73A3A"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.9 1893.96L1276.9 1904.96L1275.9 1905.46L1303.9 1977.46L1331.4 1966.46L1303.9 1893.96Z",
    fill: "#F73A3A"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M1501.9 1814.96L1474.9 1825.96L1473.9 1826.46L1501.9 1898.46L1529.4 1887.46L1501.9 1814.96Z",
    fill: "#F73A3A"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M1773.9 1705.96L1746.9 1716.96L1745.9 1717.46L1773.9 1789.46L1801.4 1778.46L1773.9 1705.96Z",
    fill: "#FF5910"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M1577.9 628.961L1548.4 640.961L1547.4 641.461L1575.9 712.461L1605.9 699.961L1577.9 628.961Z",
    fill: "#FF5910"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M1571.9 1979.96L1544.9 1990.96L1543.9 1991.46L1571.9 2063.46L1599.4 2052.46L1571.9 1979.96Z",
    fill: "#F73A3A"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.4 1722.96L973.903 1734.96L972.903 1735.46L1000.9 1806.46L1031.4 1793.46L1003.4 1722.96Z",
    fill: "#F73A3A"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M973.403 2024.96L943.903 2036.96L942.903 2037.46L971.403 2108.96L1000.9 2097.46L973.403 2024.96Z",
    fill: "#F73A3A"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.4 1865.96L1344.9 1877.96L1343.9 1878.46L1372.4 1949.96L1401.9 1938.46L1374.4 1865.96Z",
    fill: "#F73A3A"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M1569.4 1787.96L1539.9 1799.96L1538.9 1800.46L1567.4 1871.96L1596.9 1860.46L1569.4 1787.96Z",
    fill: "#F73A3A"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M1841.4 1678.96L1811.9 1690.96L1810.9 1691.46L1839.4 1762.96L1868.9 1751.46L1841.4 1678.96Z",
    fill: "#FF5910"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M1642.4 602.961L1612.9 614.961L1611.9 615.461L1640.4 686.961L1670.9 674.961L1642.4 602.961Z",
    fill: "#FF5910"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M1639.4 1952.96L1609.9 1964.96L1608.9 1965.46L1637.4 2036.96L1666.9 2025.46L1639.4 1952.96Z",
    fill: "#F73A3A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 2535.58,
    width: 454.149,
    height: 118,
    rx: 10,
    transform: "rotate(-20.9769 573 2535.58)",
    fill: "#FE763B"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M654.845 2585.86L643 2555.36L651.283 2552.14L660.536 2575.97L672.871 2571.19L675.462 2577.86L654.845 2585.86Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M690.115 2572.65C687.632 2573.61 685.316 2573.95 683.166 2573.65C681.013 2573.34 679.121 2572.49 677.492 2571.09C675.858 2569.68 674.586 2567.8 673.676 2565.46C672.766 2563.11 672.44 2560.87 672.697 2558.74C672.95 2556.6 673.77 2554.69 675.156 2553.02C676.538 2551.34 678.471 2550.02 680.954 2549.05C683.436 2548.09 685.754 2547.76 687.908 2548.07C690.057 2548.37 691.949 2549.22 693.582 2550.63C695.212 2552.03 696.482 2553.91 697.392 2556.25C698.302 2558.59 698.63 2560.84 698.377 2562.98C698.12 2565.11 697.3 2567.02 695.918 2568.7C694.532 2570.37 692.597 2571.69 690.115 2572.65ZM687.814 2566.55C688.51 2566.28 689.02 2565.81 689.345 2565.15C689.67 2564.49 689.804 2563.67 689.747 2562.7C689.69 2561.72 689.43 2560.64 688.967 2559.45C688.5 2558.25 687.962 2557.28 687.353 2556.53C686.739 2555.77 686.089 2555.26 685.401 2554.99C684.713 2554.72 684.022 2554.72 683.327 2554.99C682.592 2555.28 682.052 2555.75 681.706 2556.42C681.361 2557.1 681.217 2557.92 681.275 2558.89C681.328 2559.85 681.588 2560.93 682.055 2562.13C682.518 2563.33 683.056 2564.3 683.669 2565.06C684.283 2565.81 684.943 2566.32 685.651 2566.58C686.358 2566.85 687.08 2566.83 687.814 2566.55Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M709.91 2538.16L712.223 2544.11L697.147 2549.97L694.834 2544.01L709.91 2538.16ZM695.625 2537.39L703.848 2534.2L712.003 2555.2C712.126 2555.52 712.285 2555.77 712.479 2555.95C712.669 2556.11 712.9 2556.2 713.171 2556.23C713.438 2556.24 713.75 2556.17 714.108 2556.03C714.356 2555.94 714.632 2555.8 714.937 2555.61C715.251 2555.42 715.48 2555.27 715.624 2555.17L719.06 2560.49C718.735 2560.74 718.26 2561.08 717.637 2561.5C717.023 2561.92 716.259 2562.34 715.345 2562.75C713.497 2563.58 711.837 2564.01 710.367 2564.02C708.893 2564.02 707.627 2563.61 706.569 2562.8C705.511 2561.99 704.682 2560.78 704.081 2559.17L695.625 2537.39Z",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M742.125 2551.98L730.386 2556.54L718.542 2526.03L730.161 2521.52C733.3 2520.3 736.248 2519.86 739.006 2520.19C741.771 2520.51 744.217 2521.57 746.345 2523.38C748.48 2525.16 750.164 2527.65 751.398 2530.83C752.631 2534 753.071 2536.98 752.716 2539.74C752.358 2542.5 751.279 2544.93 749.479 2547.03C747.675 2549.13 745.224 2550.78 742.125 2551.98ZM735.939 2546.29L739.097 2545.06C740.607 2544.48 741.799 2543.73 742.672 2542.84C743.556 2541.93 744.044 2540.78 744.138 2539.37C744.241 2537.96 743.88 2536.19 743.055 2534.06C742.23 2531.94 741.298 2530.39 740.26 2529.42C739.231 2528.45 738.071 2527.94 736.78 2527.88C735.498 2527.82 734.063 2528.09 732.474 2528.71L729.554 2529.84L735.939 2546.29Z",
    fill: "white"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M769.509 2541.35L757.665 2510.84L770.833 2505.73C773.098 2504.85 775.253 2504.52 777.298 2504.76C779.343 2504.99 781.152 2505.74 782.724 2506.99C784.296 2508.24 785.502 2509.95 786.342 2512.12C787.191 2514.3 787.438 2516.38 787.086 2518.36C786.743 2520.33 785.866 2522.09 784.453 2523.63C783.051 2525.17 781.188 2526.39 778.864 2527.29L770.998 2530.35L768.5 2523.91L774.697 2521.51C775.67 2521.13 776.434 2520.64 776.988 2520.03C777.548 2519.42 777.889 2518.72 778.009 2517.94C778.14 2517.16 778.038 2516.33 777.702 2515.47C777.363 2514.6 776.885 2513.92 776.269 2513.46C775.658 2512.97 774.942 2512.7 774.119 2512.64C773.303 2512.57 772.408 2512.73 771.435 2513.1L768.515 2514.24L777.792 2538.13L769.509 2541.35Z",
    fill: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M797.158 2530.61L788.274 2507.73L796.259 2504.63L797.948 2508.98L798.186 2508.89C797.979 2507.12 798.182 2505.68 798.797 2504.59C799.421 2503.49 800.344 2502.7 801.566 2502.23C801.923 2502.09 802.287 2501.98 802.658 2501.91C803.035 2501.82 803.407 2501.76 803.773 2501.73L806.497 2508.75C806.036 2508.77 805.494 2508.86 804.871 2509.02C804.248 2509.18 803.723 2509.34 803.296 2509.51C802.491 2509.82 801.838 2510.29 801.335 2510.91C800.838 2511.51 800.533 2512.21 800.42 2513.01C800.303 2513.8 800.415 2514.63 800.754 2515.5L805.381 2527.42L797.158 2530.61Z",
    fill: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M825.162 2520.22C822.719 2521.17 820.432 2521.52 818.302 2521.27C816.178 2521.01 814.298 2520.19 812.662 2518.8C811.032 2517.4 809.739 2515.47 808.783 2513C807.865 2510.64 807.54 2508.39 807.807 2506.25C808.074 2504.11 808.886 2502.21 810.242 2500.56C811.599 2498.9 813.458 2497.61 815.822 2496.69C817.55 2496.02 819.218 2495.68 820.827 2495.68C822.435 2495.67 823.935 2495.98 825.325 2496.62C826.711 2497.25 827.954 2498.18 829.053 2499.43C830.153 2500.67 831.055 2502.2 831.761 2504.01L832.501 2505.92L812.062 2513.86L810.304 2509.33L823.175 2504.33C822.911 2503.68 822.518 2503.17 821.998 2502.8C821.483 2502.42 820.899 2502.19 820.245 2502.12C819.597 2502.05 818.93 2502.14 818.245 2502.4C817.579 2502.66 817.025 2503.04 816.58 2503.55C816.132 2504.04 815.835 2504.6 815.691 2505.23C815.556 2505.85 815.607 2506.5 815.846 2507.18L817.743 2512.06C818.028 2512.8 818.437 2513.39 818.968 2513.85C819.5 2514.31 820.117 2514.59 820.82 2514.69C821.523 2514.79 822.282 2514.69 823.097 2514.37C823.663 2514.15 824.148 2513.87 824.553 2513.53C824.968 2513.19 825.287 2512.8 825.509 2512.37C825.727 2511.93 825.833 2511.47 825.826 2510.98L833.334 2508.07C833.692 2509.76 833.618 2511.37 833.109 2512.92C832.597 2514.45 831.672 2515.85 830.333 2517.12C829.001 2518.36 827.277 2519.4 825.162 2520.22Z",
    fill: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M844.38 2485.95L846.693 2491.91L831.379 2497.85L829.066 2491.89L844.38 2485.95ZM840.869 2513.64L831.731 2490.11C830.998 2488.22 830.729 2486.52 830.922 2485.02C831.115 2483.52 831.708 2482.22 832.701 2481.12C833.693 2480.03 835.024 2479.16 836.692 2478.51C837.735 2478.11 838.779 2477.79 839.824 2477.57C840.878 2477.34 841.667 2477.2 842.19 2477.13L843.289 2483.49C842.956 2483.52 842.582 2483.58 842.165 2483.69C841.745 2483.78 841.385 2483.89 841.088 2484C840.313 2484.31 839.855 2484.67 839.714 2485.1C839.573 2485.54 839.607 2486.02 839.815 2486.56L849.092 2510.45L840.869 2513.64Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M866.866 2504.03C864.422 2504.98 862.136 2505.33 860.006 2505.08C857.882 2504.82 856.002 2504 854.366 2502.61C852.736 2501.21 851.443 2499.28 850.487 2496.81C849.569 2494.45 849.244 2492.2 849.511 2490.06C849.778 2487.92 850.59 2486.02 851.946 2484.37C853.302 2482.71 855.162 2481.42 857.526 2480.5C859.254 2479.83 860.922 2479.49 862.531 2479.49C864.139 2479.48 865.638 2479.79 867.029 2480.43C868.415 2481.06 869.658 2481.99 870.757 2483.23C871.856 2484.48 872.759 2486.01 873.464 2487.82L874.205 2489.73L853.766 2497.66L852.008 2493.14L864.879 2488.14C864.614 2487.49 864.222 2486.98 863.701 2486.61C863.187 2486.22 862.603 2486 861.949 2485.93C861.3 2485.85 860.634 2485.95 859.949 2486.21C859.283 2486.47 858.728 2486.85 858.284 2487.36C857.836 2487.85 857.539 2488.41 857.394 2489.04C857.259 2489.66 857.311 2490.31 857.55 2490.98L859.447 2495.87C859.732 2496.61 860.14 2497.2 860.672 2497.66C861.203 2498.11 861.821 2498.39 862.524 2498.5C863.227 2498.6 863.986 2498.5 864.8 2498.18C865.366 2497.96 865.852 2497.68 866.257 2497.34C866.672 2497 866.991 2496.61 867.213 2496.18C867.431 2495.74 867.536 2495.28 867.529 2494.79L875.037 2491.87C875.396 2493.56 875.321 2495.18 874.813 2496.73C874.301 2498.26 873.375 2499.66 872.037 2500.93C870.705 2502.17 868.981 2503.21 866.866 2504.03Z",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M881.262 2497.96L872.378 2475.08L880.363 2471.98L882.052 2476.33L882.29 2476.24C882.082 2474.47 882.286 2473.03 882.901 2471.94C883.525 2470.84 884.448 2470.05 885.67 2469.58C886.027 2469.44 886.391 2469.33 886.762 2469.26C887.139 2469.17 887.51 2469.11 887.877 2469.08L890.601 2476.1C890.139 2476.12 889.597 2476.21 888.975 2476.37C888.352 2476.53 887.827 2476.69 887.4 2476.86C886.595 2477.17 885.942 2477.64 885.439 2478.25C884.942 2478.86 884.637 2479.56 884.524 2480.36C884.407 2481.15 884.519 2481.98 884.858 2482.85L889.485 2494.77L881.262 2497.96Z",
    fill: "white"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M899.451 2490.9L890.567 2468.02L898.552 2464.92L900.241 2469.27L900.479 2469.18C900.271 2467.4 900.475 2465.97 901.09 2464.88C901.714 2463.78 902.637 2462.99 903.859 2462.51C904.216 2462.38 904.58 2462.27 904.951 2462.19C905.328 2462.1 905.699 2462.05 906.066 2462.02L908.79 2469.03C908.329 2469.05 907.786 2469.14 907.164 2469.31C906.541 2469.47 906.016 2469.63 905.589 2469.8C904.784 2470.11 904.131 2470.57 903.628 2471.19C903.131 2471.8 902.826 2472.5 902.713 2473.3C902.596 2474.08 902.708 2474.92 903.047 2475.79L907.674 2487.71L899.451 2490.9Z",
    fill: "white"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M927.455 2480.51C925.012 2481.46 922.725 2481.81 920.595 2481.56C918.471 2481.3 916.591 2480.47 914.955 2479.09C913.325 2477.68 912.032 2475.75 911.076 2473.29C910.158 2470.93 909.833 2468.68 910.1 2466.54C910.367 2464.4 911.179 2462.5 912.535 2460.84C913.891 2459.19 915.751 2457.9 918.115 2456.98C919.843 2456.31 921.511 2455.97 923.12 2455.96C924.728 2455.96 926.228 2456.27 927.618 2456.91C929.004 2457.54 930.247 2458.47 931.346 2459.71C932.445 2460.95 933.348 2462.48 934.053 2464.3L934.794 2466.21L914.355 2474.14L912.597 2469.61L925.468 2464.62C925.204 2463.96 924.811 2463.45 924.291 2463.09C923.776 2462.7 923.192 2462.48 922.538 2462.41C921.89 2462.33 921.223 2462.42 920.538 2462.69C919.872 2462.95 919.317 2463.33 918.873 2463.83C918.425 2464.33 918.128 2464.89 917.983 2465.52C917.849 2466.14 917.9 2466.79 918.139 2467.46L920.036 2472.35C920.321 2473.08 920.729 2473.68 921.261 2474.14C921.792 2474.59 922.41 2474.87 923.113 2474.98C923.816 2475.08 924.575 2474.97 925.389 2474.66C925.956 2474.44 926.441 2474.16 926.846 2473.82C927.261 2473.47 927.58 2473.09 927.802 2472.66C928.02 2472.22 928.125 2471.76 928.119 2471.27L935.627 2468.35C935.985 2470.04 935.91 2471.66 935.402 2473.2C934.89 2474.74 933.965 2476.14 932.626 2477.4C931.294 2478.65 929.57 2479.69 927.455 2480.51Z",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M950.249 2471.52C948.62 2472.15 946.955 2472.31 945.253 2471.99C943.561 2471.66 941.965 2470.79 940.466 2469.37C938.977 2467.95 937.72 2465.92 936.694 2463.28C935.622 2460.51 935.178 2458.1 935.361 2456.04C935.554 2453.98 936.175 2452.28 937.223 2450.95C938.281 2449.61 939.565 2448.65 941.075 2448.07C942.207 2447.63 943.277 2447.44 944.285 2447.51C945.29 2447.56 946.207 2447.81 947.038 2448.24C947.864 2448.66 948.577 2449.2 949.176 2449.86L949.295 2449.81L944.784 2438.19L953.007 2435L964.851 2465.51L956.688 2468.68L955.23 2464.92L955.052 2464.99C955.035 2465.89 954.848 2466.76 954.491 2467.61C954.14 2468.44 953.612 2469.2 952.907 2469.89C952.207 2470.56 951.322 2471.1 950.249 2471.52ZM950.836 2464.02C951.591 2463.73 952.151 2463.26 952.518 2462.62C952.891 2461.96 953.065 2461.17 953.04 2460.25C953.022 2459.32 952.797 2458.3 952.365 2457.19C951.926 2456.06 951.401 2455.15 950.791 2454.46C950.187 2453.76 949.528 2453.3 948.816 2453.08C948.111 2452.85 947.38 2452.89 946.625 2453.18C945.871 2453.47 945.31 2453.94 944.943 2454.59C944.583 2455.22 944.417 2456 944.445 2456.92C944.479 2457.84 944.716 2458.86 945.155 2459.99C945.595 2461.12 946.112 2462.04 946.706 2462.75C947.306 2463.44 947.954 2463.9 948.65 2464.14C949.353 2464.35 950.081 2464.32 950.836 2464.02Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotD);
export default __webpack_public_path__ + "static/media/LotD.32c36e07e03704bf57b144b684ca1d30.svg";
export { ForwardRef as ReactComponent };